/* Track Insight reviewer workspace live v6.11 — tonal balance layout polish */
/* Track Insight reviewer workspace live v6.8 — robust MIDI actions */
/* Track Insight reviewer workspace live v6.7 — persistent reviewer session */
/* Track Insight reviewer workspace live v6.6 — Complete MIDI workflow */
/* Track Insight reviewer workspace live v6.5 — publish delivery guard */
/* Track Insight reviewer workspace live v6.4 — private video delivery */
/* Track Insight reviewer workspace live v6.3 — service-tier aware */
/* Track Insight reviewer workspace live v6.2 — organised Second Opinion review builder */
/* Track Insight reviewer workspace live v6.1 — expanded Second Opinion */
/* MAG Signature Sound — Track Insight live reviewer workspace */
(function () {
  'use strict';

  var PROJECT_REF = 'jbllyryqhalyltkkkljn';
  var SUPABASE_URL = 'https://' + PROJECT_REF + '.supabase.co';
  var FUNCTIONS_BASE = SUPABASE_URL + '/functions/v1';
  var PUBLISHABLE_KEY = 'sb_publishable_5RYKqGrMbtlyHTfX5D5IHQ_BDLSoNMz';
  var STORAGE_KEY = 'mag_track_insight_reviewer_auth';
  var REFRESH_SKEW_MS = 60000;
  var WAVESURFER_SRC = 'https://unpkg.com/wavesurfer.js@6.6';
  var LAME_SRC = 'https://cdn.jsdelivr.net/npm/lamejs@1.2.1/lame.min.js';

  function loadSession() {
    try {
      var persistent = localStorage.getItem(STORAGE_KEY);
      if (persistent) {
        var localSession = JSON.parse(persistent);
        sessionStorage.setItem(STORAGE_KEY, persistent);
        return localSession;
      }

      var tabSessionRaw = sessionStorage.getItem(STORAGE_KEY);
      if (!tabSessionRaw) return null;

      var tabSession = JSON.parse(tabSessionRaw);

      // One-time migration from the old tab-only reviewer session.
      // After a reviewer signs in and opens any workspace once, future
      // reviewer workspace tabs can reuse the same refreshable session.
      localStorage.setItem(STORAGE_KEY, tabSessionRaw);
      return tabSession;
    } catch (_) {
      return null;
    }
  }

  function saveSession(data, previous) {
    var session = {
      access_token: data.access_token,
      refresh_token: data.refresh_token || (previous && previous.refresh_token) || null,
      expires_at: Date.now() + (Number(data.expires_in || 3600) * 1000),
      user: data.user || (previous && previous.user) || null,
      recovery: false
    };

    var serialised = JSON.stringify(session);
    sessionStorage.setItem(STORAGE_KEY, serialised);
    localStorage.setItem(STORAGE_KEY, serialised);
    return session;
  }

  function clearSession() {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  }

  async function parseJson(response) {
    var body = {};

    try {
      body = await response.json();
    } catch (_) {}

    if (!response.ok) {
      throw new Error(
        body.error_description ||
        body.msg ||
        body.error ||
        ('Request failed (' + response.status + ')')
      );
    }

    return body;
  }

  async function refreshSession(session) {
    if (!session || !session.refresh_token) {
      clearSession();
      throw new Error('Reviewer session expired. Return to the review queue and sign in again.');
    }

    var response = await fetch(
      SUPABASE_URL + '/auth/v1/token?grant_type=refresh_token',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': PUBLISHABLE_KEY
        },
        body: JSON.stringify({
          refresh_token: session.refresh_token
        })
      }
    );

    return saveSession(await parseJson(response), session);
  }

  async function getSession() {
    var session = loadSession();

    if (!session || !session.access_token) {
      return null;
    }

    if (!session.expires_at || session.expires_at <= Date.now() + REFRESH_SKEW_MS) {
      session = await refreshSession(session);
    }

    return session;
  }

  async function reviewerApi(action, params) {
    var session = await getSession();

    if (!session) {
      throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
    }

    async function request(currentSession) {
      return fetch(FUNCTIONS_BASE + '/reviewer-api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + currentSession.access_token
        },
        body: JSON.stringify(Object.assign({ action: action }, params || {}))
      });
    }

    var response = await request(session);

    if (response.status === 401 && session.refresh_token) {
      session = await refreshSession(session);
      response = await request(session);
    }

    return parseJson(response);
  }


  async function notificationApi(params) {
    var session = await getSession();

    if (!session) {
      throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
    }

    async function request(currentSession) {
      return fetch(FUNCTIONS_BASE + '/track-insight-notifications', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + currentSession.access_token
        },
        body: JSON.stringify(params || {})
      });
    }

    var response = await request(session);

    if (response.status === 401 && session.refresh_token) {
      session = await refreshSession(session);
      response = await request(session);
    }

    return parseJson(response);
  }


  async function diagnosticsApi(action, params) {
    var session = await getSession();

    if (!session) {
      throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
    }

    async function request(currentSession) {
      return fetch(FUNCTIONS_BASE + '/reviewer-diagnostics-api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + currentSession.access_token
        },
        body: JSON.stringify(Object.assign({ action: action }, params || {}))
      });
    }

    var response = await request(session);

    if (response.status === 401 && session.refresh_token) {
      session = await refreshSession(session);
      response = await request(session);
    }

    return parseJson(response);
  }

  async function secondOpinionApi(action, params) {
    var session = await getSession();

    if (!session) {
      throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
    }

    async function request(currentSession) {
      return fetch(FUNCTIONS_BASE + '/track-insight-second-opinion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + currentSession.access_token
        },
        body: JSON.stringify(Object.assign({ action: action }, params || {}))
      });
    }

    var response = await request(session);

    if (response.status === 401 && session.refresh_token) {
      session = await refreshSession(session);
      response = await request(session);
    }

    return parseJson(response);
  }


  async function midiReviewerApi(action, params) {
    var session = await getSession();

    if (!session) {
      throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
    }

    async function request(currentSession) {
      return fetch(FUNCTIONS_BASE + '/track-insight-midi-reviewer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + currentSession.access_token
        },
        body: JSON.stringify(Object.assign({ action: action }, params || {}))
      });
    }

    var response = await request(session);

    if (response.status === 401 && session.refresh_token) {
      session = await refreshSession(session);
      response = await request(session);
    }

    return parseJson(response);
  }

  function getSubmissionId() {
    return new URLSearchParams(window.location.search).get('submission');
  }

  function formatDate(value) {
    if (!value) return '—';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';

    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(date);
  }

  function formatTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';

    var total = Math.floor(seconds);
    var minutes = Math.floor(total / 60);
    var secs = total % 60;

    return minutes + ':' + String(secs).padStart(2, '0');
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value == null ? '' : String(value);
  }

  function setWorkspaceMessage(root, message, isError) {
    var target = root.querySelector('[data-ti-workspace-live-status]');

    if (!target) {
      target = document.createElement('p');
      target.setAttribute('data-ti-workspace-live-status', '');
      target.style.margin = '14px 0 0';
      target.style.fontSize = '10px';
      target.style.fontWeight = '800';
      target.style.letterSpacing = '.08em';
      target.style.textTransform = 'uppercase';

      var actions = root.querySelector('.ti-workspace__head-actions');
      if (actions) actions.parentNode.insertBefore(target, actions.nextSibling);
    }

    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function setPlayIcon(button, playing) {
    if (!button) return;

    button.setAttribute('aria-label', playing ? 'Pause track' : 'Play track');

    if (playing) {
      button.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" style="transform:none">' +
          '<path d="M7 5h4v14H7zM13 5h4v14h-4z"></path>' +
        '</svg>';
    } else {
      button.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M8 5v14l11-7z"></path>' +
        '</svg>';
    }
  }


  function serviceTierInfo(value) {
    var tier = String(value || 'standard').toLowerCase();

    if (tier === 'complete') {
      return {
        key: 'complete',
        name: 'TRACK INSIGHT COMPLETE',
        price: '£129',
        description: 'Full Track Insight report + personalised video review + 2 bespoke MIDI corrections / enhancements.',
        video: true,
        midi: true
      };
    }

    if (tier === 'video') {
      return {
        key: 'video',
        name: 'TRACK INSIGHT + VIDEO',
        price: '£89',
        description: 'Full Track Insight report + personalised screen-recorded video review.',
        video: true,
        midi: false
      };
    }

    return {
      key: 'standard',
      name: 'TRACK INSIGHT',
      price: '£49',
      description: 'Full written Track Insight review.',
      video: false,
      midi: false
    };
  }

  function renderServiceTier(root, submission) {
    var info = serviceTierInfo(submission && submission.service_tier);
    var tierRoot = root.querySelector('[data-ti-service-tier]');
    if (!tierRoot) return;

    tierRoot.setAttribute('data-tier', info.key);

    setText(root, '[data-ti-tier-name]', info.name);
    setText(root, '[data-ti-tier-price]', info.price);
    setText(root, '[data-ti-tier-description]', info.description);
    setText(root, '[data-ti-tier-report-status]', 'Included');
    setText(root, '[data-ti-tier-video-status]', info.video ? 'Included' : 'Not included');
    setText(root, '[data-ti-tier-midi-status]', info.midi ? '2 included' : 'Not included');

    var report = root.querySelector('[data-ti-tier-deliverable="report"]');
    var video = root.querySelector('[data-ti-tier-deliverable="video"]');
    var midi = root.querySelector('[data-ti-tier-deliverable="midi"]');

    if (report) report.classList.add('is-included');
    if (video) video.classList.toggle('is-included', info.video);
    if (midi) midi.classList.toggle('is-included', info.midi);

    var videoPanel = root.querySelector('[data-ti-video-panel]');
    if (videoPanel) videoPanel.hidden = !info.video;

    var midiPanel = root.querySelector('[data-ti-midi-panel]');
    if (midiPanel) midiPanel.hidden = !info.midi;
  }


  function setVideoMessage(root, message, isError) {
    var target = root.querySelector('[data-ti-video-message]');
    if (!target) return;
    target.textContent = message || '';
    target.classList.toggle('is-error', !!isError);
  }

  function setVideoProgress(root, percent) {
    var wrap = root.querySelector('[data-ti-video-progress-wrap]');
    var bar = root.querySelector('[data-ti-video-progress]');
    var label = root.querySelector('[data-ti-video-progress-label]');
    percent = Math.max(0, Math.min(100, Number(percent || 0)));

    if (wrap) wrap.hidden = false;
    if (bar) bar.style.width = percent + '%';
    if (label) label.textContent = Math.round(percent) + '%';
  }

  function uploadVideoToSignedUrl(url, file, root) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var form = new FormData();

      form.append('cacheControl', '3600');
      form.append('', file);

      xhr.open('PUT', url, true);
      xhr.setRequestHeader('x-upsert', 'true');

      xhr.upload.addEventListener('progress', function (event) {
        if (!event.lengthComputable) return;
        setVideoProgress(root, (event.loaded / event.total) * 100);
      });

      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          setVideoProgress(root, 100);
          resolve();
          return;
        }

        var message = 'Video upload failed (' + xhr.status + ').';
        try {
          var body = JSON.parse(xhr.responseText || '{}');
          message = body.message || body.error || message;
        } catch (_) {}
        reject(new Error(message));
      });

      xhr.addEventListener('error', function () {
        reject(new Error('Video upload failed. Check your connection and try again.'));
      });

      xhr.send(form);
    });
  }

  async function loadVideoPlayback(root, submissionId) {
    var previewWrap = root.querySelector('[data-ti-video-preview-wrap]');
    var preview = root.querySelector('[data-ti-video-preview]');
    if (!previewWrap || !preview) return;

    var response = await reviewerApi('get_video_playback_url', {
      submission_id: submissionId
    });

    if (!response || !response.url) throw new Error('Video playback URL was not returned.');

    preview.src = response.url;
    previewWrap.hidden = false;
  }

  function renderVideoReviewState(root, state) {
    var status = String((state && state.status) || 'not_started');
    var badge = root.querySelector('[data-ti-video-status]');
    var name = root.querySelector('[data-ti-video-ready-name]');
    var previewWrap = root.querySelector('[data-ti-video-preview-wrap]');

    if (badge) {
      badge.textContent =
        status === 'ready' ? 'READY' :
        status === 'uploading' ? 'UPLOADING' :
        status === 'error' ? 'ERROR' :
        'NOT STARTED';
      badge.classList.toggle('is-ready', status === 'ready');
    }

    if (name && state && state.original_filename) {
      name.textContent = state.original_filename;
    }

    if (previewWrap && status !== 'ready') {
      previewWrap.hidden = true;
    }
  }

  async function initVideoReview(root, submissionId, submission) {
    var info = serviceTierInfo(submission && submission.service_tier);
    var panel = root.querySelector('[data-ti-video-panel]');
    if (!panel) return;

    panel.hidden = !info.video;
    if (!info.video) return;

    var fileInput = root.querySelector('[data-ti-video-file]');
    var chooseButton = root.querySelector('[data-ti-video-choose]');
    var uploadButton = root.querySelector('[data-ti-video-upload]');
    var filename = root.querySelector('[data-ti-video-filename]');
    var refreshButton = root.querySelector('[data-ti-video-refresh]');
    var selectedFile = null;

    try {
      var response = await reviewerApi('get_video_review', {
        submission_id: submissionId
      });

      var state = response && response.video_review ? response.video_review : { status: 'not_started' };
      renderVideoReviewState(root, state);

      if (state.status === 'ready') {
        await loadVideoPlayback(root, submissionId);
      }
    } catch (error) {
      console.error('[Track Insight video load]', error);
      setVideoMessage(root, error.message || String(error), true);
    }

    if (chooseButton && fileInput && chooseButton.dataset.tiBound !== 'true') {
      chooseButton.dataset.tiBound = 'true';
      chooseButton.addEventListener('click', function () {
        fileInput.click();
      });
    }

    if (fileInput && fileInput.dataset.tiBound !== 'true') {
      fileInput.dataset.tiBound = 'true';
      fileInput.addEventListener('change', function () {
        selectedFile = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;

        if (filename) {
          filename.textContent = selectedFile ? selectedFile.name : 'No video selected';
        }

        if (uploadButton) {
          uploadButton.disabled = !selectedFile;
          uploadButton.textContent = selectedFile ? 'Upload Video Review' : 'Upload Video Review';
        }

        setVideoMessage(root, selectedFile ? 'Ready to upload.' : '', false);
      });
    }

    if (uploadButton && uploadButton.dataset.tiBound !== 'true') {
      uploadButton.dataset.tiBound = 'true';
      uploadButton.addEventListener('click', async function () {
        if (!selectedFile) return;

        var originalText = uploadButton.textContent;
        uploadButton.disabled = true;
        uploadButton.textContent = 'Preparing Upload…';
        setVideoMessage(root, 'Creating secure upload…', false);
        setVideoProgress(root, 0);

        try {
          var started = await reviewerApi('start_video_upload', {
            submission_id: submissionId,
            original_filename: selectedFile.name,
            file_type: selectedFile.type || 'video/mp4',
            file_size_bytes: selectedFile.size
          });

          if (!started || !started.signed_upload_url) {
            throw new Error('Secure video upload URL was not returned.');
          }

          uploadButton.textContent = 'Uploading…';
          setVideoMessage(root, 'Uploading private video review…', false);

          await uploadVideoToSignedUrl(started.signed_upload_url, selectedFile, root);

          uploadButton.textContent = 'Finalising…';

          await reviewerApi('complete_video_upload', {
            submission_id: submissionId
          });

          var refreshed = await reviewerApi('get_video_review', {
            submission_id: submissionId
          });

          var state = refreshed && refreshed.video_review ? refreshed.video_review : { status: 'ready' };
          renderVideoReviewState(root, state);
          await loadVideoPlayback(root, submissionId);

          setVideoMessage(root, 'Video review uploaded and ready for customer delivery.', false);
          selectedFile = null;
          fileInput.value = '';
          if (filename) filename.textContent = state.original_filename || 'Video review ready';
        } catch (error) {
          console.error('[Track Insight video upload]', error);
          setVideoMessage(root, error.message || String(error), true);
        } finally {
          uploadButton.disabled = !selectedFile;
          uploadButton.textContent = originalText;
        }
      });
    }

    if (refreshButton && refreshButton.dataset.tiBound !== 'true') {
      refreshButton.dataset.tiBound = 'true';
      refreshButton.addEventListener('click', async function () {
        refreshButton.disabled = true;
        try {
          await loadVideoPlayback(root, submissionId);
        } catch (error) {
          setVideoMessage(root, error.message || String(error), true);
        } finally {
          refreshButton.disabled = false;
        }
      });
    }
  }


  function midiStatusLabel(value) {
    var status = String(value || 'not_started');
    if (status === 'source_required') return 'SOURCE REQUIRED';
    if (status === 'source_received') return 'SOURCE RECEIVED';
    if (status === 'in_progress') return 'IN PROGRESS';
    if (status === 'ready') return 'READY';
    return 'NOT STARTED';
  }

  function setMidiMessage(card, message, error) {
    var target = card.querySelector('[data-ti-midi-message]');
    if (!target) return;
    target.textContent = message || '';
    target.classList.toggle('is-error', !!error);
  }

  function midiFileMarkup(file) {
    return (
      '<div class="ti-workspace__midi-file">' +
        '<strong>' + escapeHtml(file.original_filename || 'MIDI file') + '</strong>' +
        '<button type="button" data-ti-midi-download="' + escapeHtml(file.id) + '">Download</button>' +
      '</div>'
    );
  }

  function renderMidiEnhancement(root, enhancement) {
    var card = root.querySelector('[data-ti-midi-card][data-position="' + enhancement.position + '"]');
    if (!card) return;

    card.dataset.enhancementId = enhancement.id;
    card.classList.toggle('is-ready', enhancement.status === 'ready');

    var title = card.querySelector('[data-ti-midi-title]');
    var description = card.querySelector('[data-ti-midi-description]');
    var requestNote = card.querySelector('[data-ti-midi-request-note]');
    var internalNote = card.querySelector('[data-ti-midi-internal-note]');
    var cardTitle = card.querySelector('[data-ti-midi-card-title]');
    var status = card.querySelector('[data-ti-midi-status]');
    var sourceState = card.querySelector('[data-ti-midi-source-state]');
    var sourceList = card.querySelector('[data-ti-midi-source-list]');
    var completedList = card.querySelector('[data-ti-midi-completed-list]');
    var readyButton = card.querySelector('[data-ti-midi-ready]');

    if (title) title.value = enhancement.title || '';
    if (description) description.value = enhancement.description || '';
    if (requestNote) requestNote.value = enhancement.customer_request_note || '';
    if (internalNote) internalNote.value = enhancement.reviewer_internal_note || '';
    if (cardTitle) cardTitle.textContent = enhancement.title || 'NOT DEFINED';

    if (status) {
      status.textContent = midiStatusLabel(enhancement.status);
      status.classList.toggle('is-ready', enhancement.status === 'ready');
    }

    if (sourceState) {
      sourceState.textContent =
        enhancement.status === 'source_required' ? 'AWAITING CUSTOMER' :
        enhancement.source_files && enhancement.source_files.length ? 'RECEIVED' :
        enhancement.source_required ? 'REQUESTED' :
        'NOT REQUESTED';
    }

    var sourceFiles = enhancement.source_files || [];
    var completedFiles = enhancement.completed_files || [];

    if (sourceList) {
      sourceList.innerHTML = sourceFiles.length
        ? sourceFiles.map(midiFileMarkup).join('')
        : '<p>No source files received.</p>';
    }

    if (completedList) {
      completedList.innerHTML = completedFiles.length
        ? completedFiles.map(midiFileMarkup).join('')
        : '<p>No finished MIDI uploaded.</p>';
    }

    if (readyButton) {
      readyButton.disabled = enhancement.status === 'ready' || completedFiles.length === 0;
      readyButton.textContent = enhancement.status === 'ready'
        ? 'Enhancement Ready'
        : 'Mark Enhancement Ready';
    }
  }

  function renderMidiWorkflow(root, enhancements) {
    enhancements = Array.isArray(enhancements) ? enhancements : [];
    enhancements.forEach(function (enhancement) {
      renderMidiEnhancement(root, enhancement);
    });

    var readyCount = enhancements.filter(function (item) {
      return String(item.status || '') === 'ready';
    }).length;

    var overall = root.querySelector('[data-ti-midi-overall-status]');
    if (overall) {
      overall.textContent = readyCount === 2 ? '2 / 2 READY' : (2 - readyCount) + ' TO COMPLETE';
      overall.classList.toggle('is-ready', readyCount === 2);
    }
  }

  async function refreshMidiWorkflow(root, submissionId) {
    var response = await midiReviewerApi('get_workflow', {
      submission_id: submissionId
    });

    var enhancements = response && Array.isArray(response.enhancements)
      ? response.enhancements
      : [];

    renderMidiWorkflow(root, enhancements);
    return enhancements;
  }


  async function ensureMidiEnhancementForCard(root, card, submissionId) {
    if (card.dataset.enhancementId) {
      return card.dataset.enhancementId;
    }

    var response = await midiReviewerApi('get_workflow', {
      submission_id: submissionId
    });

    var position = Number(card.getAttribute('data-position'));
    var enhancement = (response.enhancements || []).find(function (item) {
      return Number(item.position) === position;
    });

    if (!enhancement || !enhancement.id) {
      throw new Error('Could not initialise MIDI Enhancement ' + position + '. Refresh the page and try again.');
    }

    card.dataset.enhancementId = enhancement.id;
    renderMidiEnhancement(root, enhancement);

    return enhancement.id;
  }

  function midiPayloadFromCard(card, submissionId, status, sourceRequired) {
    return {
      submission_id: submissionId,
      enhancement_id: card.dataset.enhancementId,
      title: (card.querySelector('[data-ti-midi-title]') || {}).value || '',
      description: (card.querySelector('[data-ti-midi-description]') || {}).value || '',
      customer_request_note: (card.querySelector('[data-ti-midi-request-note]') || {}).value || '',
      reviewer_internal_note: (card.querySelector('[data-ti-midi-internal-note]') || {}).value || '',
      status: status,
      source_required: sourceRequired
    };
  }

  function uploadMidiSignedUrl(url, file) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var form = new FormData();

      form.append('cacheControl', '3600');
      form.append('', file);

      xhr.open('PUT', url, true);

      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
          return;
        }

        reject(new Error('MIDI upload failed (' + xhr.status + ').'));
      });

      xhr.addEventListener('error', function () {
        reject(new Error('MIDI upload failed. Check your connection and try again.'));
      });

      xhr.send(form);
    });
  }

  async function initMidiWorkflow(root, submissionId, submission) {
    var info = serviceTierInfo(submission && submission.service_tier);
    var panel = root.querySelector('[data-ti-midi-panel]');
    if (!panel) return;

    panel.hidden = !info.midi;
    if (!info.midi) return;

    try {
      await refreshMidiWorkflow(root, submissionId);
    } catch (error) {
      console.error('[Track Insight MIDI initial load]', error);
      Array.prototype.forEach.call(root.querySelectorAll('[data-ti-midi-card]'), function (card) {
        setMidiMessage(card, error.message || String(error), true);
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-ti-midi-card]'), function (card) {
      if (card.dataset.tiMidiBound === 'true') return;
      card.dataset.tiMidiBound = 'true';

      var save = card.querySelector('[data-ti-midi-save]');
      var requestSource = card.querySelector('[data-ti-midi-request-source]');
      var startWork = card.querySelector('[data-ti-midi-start-work]');
      var ready = card.querySelector('[data-ti-midi-ready]');
      var fileInput = card.querySelector('[data-ti-midi-completed-file]');
      var choose = card.querySelector('[data-ti-midi-choose]');
      var upload = card.querySelector('[data-ti-midi-upload]');
      var selected = card.querySelector('[data-ti-midi-selected]');
      var selectedFile = null;

      async function updateCard(status, sourceRequired, message) {
        setMidiMessage(card, message || 'Saving…', false);

        try {
          await ensureMidiEnhancementForCard(root, card, submissionId);

          var response = await midiReviewerApi(
            'update_enhancement',
            midiPayloadFromCard(card, submissionId, status, sourceRequired)
          );

          renderMidiWorkflow(root, response.enhancements || []);

          if (status === 'source_required') {
            setMidiMessage(card, 'Source MIDI requested — the customer dashboard will now show Action Required.', false);
          } else {
            setMidiMessage(card, 'Saved.', false);
          }
        } catch (error) {
          console.error('[Track Insight MIDI update]', error);
          setMidiMessage(card, error.message || String(error), true);
        }
      }

      if (save) {
        save.addEventListener('click', async function () {
          setMidiMessage(card, 'Saving brief…', false);

          try {
            await ensureMidiEnhancementForCard(root, card, submissionId);

            var response = await midiReviewerApi('get_workflow', {
              submission_id: submissionId
            });

            var position = Number(card.getAttribute('data-position'));
            var currentItem = (response.enhancements || []).find(function (item) {
              return Number(item.position) === position;
            });

            await updateCard(
              currentItem ? currentItem.status : 'not_started',
              currentItem ? !!currentItem.source_required : false,
              'Saving brief…'
            );
          } catch (error) {
            console.error('[Track Insight MIDI save]', error);
            setMidiMessage(card, error.message || String(error), true);
          }
        });
      }

      if (requestSource) {
        requestSource.addEventListener('click', function () {
          updateCard('source_required', true, 'Requesting customer MIDI…');
        });
      }

      if (startWork) {
        startWork.addEventListener('click', function () {
          updateCard('in_progress', false, 'Starting work…');
        });
      }

      if (ready) {
        ready.addEventListener('click', function () {
          updateCard('ready', false, 'Finalising enhancement…');
        });
      }

      if (choose && fileInput) {
        choose.addEventListener('click', function () {
          fileInput.click();
        });
      }

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          selectedFile = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
          if (selected) selected.textContent = selectedFile ? selectedFile.name : 'No file selected';
          if (upload) upload.disabled = !selectedFile;
        });
      }

      if (upload) {
        upload.addEventListener('click', async function () {
          if (!selectedFile || !card.dataset.enhancementId) return;

          upload.disabled = true;
          var original = upload.textContent;
          upload.textContent = 'Uploading…';
          setMidiMessage(card, 'Uploading finished MIDI…', false);

          try {
            var started = await midiReviewerApi('start_completed_upload', {
              submission_id: submissionId,
              enhancement_id: card.dataset.enhancementId,
              original_filename: selectedFile.name,
              file_size_bytes: selectedFile.size
            });

            await uploadMidiSignedUrl(started.signed_upload_url, selectedFile);

            var completed = await midiReviewerApi('complete_completed_upload', {
              submission_id: submissionId,
              enhancement_id: card.dataset.enhancementId,
              storage_path: started.storage_path,
              original_filename: selectedFile.name,
              file_size_bytes: selectedFile.size
            });

            renderMidiWorkflow(root, completed.enhancements || []);
            selectedFile = null;
            fileInput.value = '';
            if (selected) selected.textContent = 'No file selected';
            setMidiMessage(card, 'Finished MIDI uploaded. Add any related files, then mark this enhancement ready.', false);
          } catch (error) {
            setMidiMessage(card, error.message || String(error), true);
          } finally {
            upload.textContent = original;
            upload.disabled = !selectedFile;
          }
        });
      }

      card.addEventListener('click', async function (event) {
        var button = event.target.closest('[data-ti-midi-download]');
        if (!button) return;

        button.disabled = true;

        try {
          var response = await midiReviewerApi('get_file_url', {
            submission_id: submissionId,
            file_id: button.getAttribute('data-ti-midi-download')
          });

          if (!response || !response.url) throw new Error('MIDI download URL was not returned.');

          var link = document.createElement('a');
          link.href = response.url;
          link.target = '_blank';
          link.rel = 'noopener';
          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (error) {
          setMidiMessage(card, error.message || String(error), true);
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  function populateSubmission(root, submission) {
    renderServiceTier(root, submission);
    setText(root, '[data-ti-review-customer]', submission.customer_name || submission.customer_email || 'Customer');
    setText(root, '[data-ti-review-artist]', submission.artist_name || 'Untitled Artist');
    setText(root, '[data-ti-review-track]', submission.track_title || 'Untitled Track');
    setText(root, '[data-ti-review-submitted]', formatDate(submission.submitted_at));
    setText(root, '[data-ti-review-status]', submission.status || 'In Review');

    var title = root.querySelector('.ti-workspace__player-title');
    if (title) {
      title.textContent =
        (submission.artist_name || 'Untitled Artist') +
        ' — ' +
        (submission.track_title || 'Untitled Track');
    }

    var duration = Number(submission.track_duration_seconds);
    if (Number.isFinite(duration) && duration > 0) {
      setText(root, '[data-ti-review-duration]', formatTime(duration));
    }

    setText(root, '[data-ti-review-current]', '0:00');

    var markerList = root.querySelector('[data-ti-marker-list]');
    if (markerList && markerList.dataset.tiLiveCleared !== 'true') {
      markerList.innerHTML = '';
      markerList.dataset.tiLiveCleared = 'true';
    }
  }

  function loadWaveSurfer() {
    if (window.WaveSurfer) {
      return Promise.resolve(window.WaveSurfer);
    }

    if (window.__tiWorkspaceWaveSurferPromise) {
      return window.__tiWorkspaceWaveSurferPromise;
    }

    window.__tiWorkspaceWaveSurferPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-ti-workspace-wavesurfer]');

      if (existing) {
        existing.addEventListener('load', function () {
          resolve(window.WaveSurfer);
        }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = WAVESURFER_SRC;
      script.async = true;
      script.setAttribute('data-ti-workspace-wavesurfer', '');
      script.onload = function () {
        if (window.WaveSurfer) {
          resolve(window.WaveSurfer);
        } else {
          reject(new Error('WaveSurfer loaded but did not initialise.'));
        }
      };
      script.onerror = function () {
        reject(new Error('WaveSurfer could not be loaded.'));
      };
      document.head.appendChild(script);
    });

    return window.__tiWorkspaceWaveSurferPromise;
  }

  async function createPlayer(root, submissionId) {
    var playback = await reviewerApi('get_playback_url', {
      submission_id: submissionId
    });

    if (!playback || !playback.url) {
      throw new Error('Playback URL was not returned.');
    }

    await loadWaveSurfer();

    var waveform = root.querySelector('[data-ti-review-waveform]');
    if (!waveform) {
      throw new Error('Waveform container was not found.');
    }

    waveform.innerHTML = '';

    var liveWave = document.createElement('div');
    liveWave.setAttribute('data-ti-live-wave', '');
    liveWave.style.position = 'relative';
    liveWave.style.zIndex = '2';
    liveWave.style.width = '100%';
    liveWave.style.height = '100%';
    waveform.appendChild(liveWave);

    var player = window.WaveSurfer.create({
      container: liveWave,
      waveColor: '#C7D2D0',
      progressColor: '#D67E4A',
      cursorColor: '#D67E4A',
      cursorWidth: 1,
      height: 218,
      responsive: true,
      normalize: true,
      hideScrollbar: true,
      barWidth: 3,
      barGap: 2,
      barRadius: 2
    });

    var playButton = root.querySelector('[data-ti-review-play]');
    var current = root.querySelector('[data-ti-review-current]');
    var duration = root.querySelector('[data-ti-review-duration]');

    function updateTime() {
      if (current) current.textContent = formatTime(player.getCurrentTime());
      if (duration && player.getDuration()) duration.textContent = formatTime(player.getDuration());
    }

    if (playButton) {
      playButton.addEventListener('click', function () {
        player.playPause();
      });
    }

    player.on('ready', function () {
      updateTime();
      setWorkspaceMessage(root, 'Live WAV loaded');
    });

    player.on('audioprocess', updateTime);
    player.on('seek', updateTime);
    player.on('interaction', updateTime);
    player.on('play', function () {
      setPlayIcon(playButton, true);
    });
    player.on('pause', function () {
      setPlayIcon(playButton, false);
    });
    player.on('finish', function () {
      setPlayIcon(playButton, false);
      updateTime();
    });
    player.on('error', function (error) {
      console.error('[Track Insight WaveSurfer]', error);
      setWorkspaceMessage(root, 'Waveform playback error', true);
    });

    setPlayIcon(playButton, false);
    player.load(playback.url);

    return player;
  }


  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function markerTimeInput(timestampMs) {
    var seconds = Math.max(0, Math.floor(Number(timestampMs || 0) / 1000));
    var minutes = Math.floor(seconds / 60);
    var secs = seconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  }

  function parseMarkerTime(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return 0;

    if (/^\d+(?:\.\d+)?$/.test(raw)) {
      return Math.max(0, Math.round(Number(raw) * 1000));
    }

    var parts = raw.split(':').map(function (part) {
      return Number(part);
    });

    if (parts.some(function (part) { return !Number.isFinite(part); })) {
      return 0;
    }

    var seconds = 0;
    if (parts.length === 2) {
      seconds = (parts[0] * 60) + parts[1];
    } else if (parts.length === 3) {
      seconds = (parts[0] * 3600) + (parts[1] * 60) + parts[2];
    } else {
      return 0;
    }

    return Math.max(0, Math.round(seconds * 1000));
  }


  function renumberLiveMarkers(root) {
    root.querySelectorAll('[data-ti-marker-row]').forEach(function (row, index) {
      var num = row.querySelector('.ti-workspace__editor-num');
      if (num) num.textContent = String(index + 1).padStart(2, '0');
      row.dataset.tiMarkerNumber = String(index + 1);
    });
  }

  function markerRowStatus(row, message, isError) {
    var target = row.querySelector('[data-ti-marker-save-state]');

    if (!target) {
      target = document.createElement('span');
      target.setAttribute('data-ti-marker-save-state', '');
      target.style.gridColumn = '2 / -1';
      target.style.marginTop = '-8px';
      target.style.fontSize = '8px';
      target.style.fontWeight = '800';
      target.style.letterSpacing = '.08em';
      target.style.textTransform = 'uppercase';
      row.appendChild(target);
    }

    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function makeLiveMarkerRow(root, marker) {
    var markerList = root.querySelector('[data-ti-marker-list]');
    if (!markerList) return null;

    var row = document.createElement('div');
    row.className = 'ti-workspace__editor-row';
    row.setAttribute('data-ti-marker-row', '');

    if (marker && marker.id) {
      row.dataset.tiMarkerId = marker.id;
    }

    var timestampMs = marker && marker.timestamp_ms != null ? Number(marker.timestamp_ms) : 0;
    var category = marker && marker.category ? marker.category : '';
    var title = marker && marker.title ? marker.title : '';
    var feedback = marker && marker.feedback ? marker.feedback : '';

    row.innerHTML =
      '<span class="ti-workspace__editor-num">00</span>' +
      '<input class="ti-workspace__input" value="' + escapeHtml(markerTimeInput(timestampMs)) + '" aria-label="Timestamp" data-ti-marker-time>' +
      '<input class="ti-workspace__input" type="text" value="' + escapeHtml(category) + '" placeholder="Area / topic" aria-label="Area or topic" data-ti-marker-category>' +
      '<input class="ti-workspace__input" value="' + escapeHtml(title) + '" placeholder="Feedback heading" aria-label="Heading" data-ti-marker-heading>' +
      '<textarea class="ti-workspace__textarea" placeholder="Write the timestamped feedback" aria-label="Feedback" data-ti-marker-feedback>' + escapeHtml(feedback) + '</textarea>' +
      '<button class="ti-workspace__delete" type="button" aria-label="Delete marker" data-ti-delete-marker>×</button>';

    markerList.appendChild(row);
    renumberLiveMarkers(root);
    return row;
  }

  function sortLiveMarkerRows(root) {
    var list = root.querySelector('[data-ti-marker-list]');
    if (!list) return;

    var rows = Array.prototype.slice.call(list.querySelectorAll('[data-ti-marker-row]'));
    rows.sort(function (a, b) {
      var at = parseMarkerTime(a.querySelector('[data-ti-marker-time]') && a.querySelector('[data-ti-marker-time]').value);
      var bt = parseMarkerTime(b.querySelector('[data-ti-marker-time]') && b.querySelector('[data-ti-marker-time]').value);
      return at - bt;
    });

    rows.forEach(function (row) {
      list.appendChild(row);
    });

    renumberLiveMarkers(root);
  }

  function ensureMarkerOverlay(root) {
    var waveform = root.querySelector('[data-ti-review-waveform]');
    if (!waveform) return null;

    waveform.style.position = 'relative';

    var overlay = waveform.querySelector('[data-ti-live-marker-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.setAttribute('data-ti-live-marker-overlay', '');
      overlay.style.position = 'absolute';
      overlay.style.inset = '0';
      overlay.style.zIndex = '5';
      overlay.style.pointerEvents = 'none';
      waveform.appendChild(overlay);
    }

    return overlay;
  }

  function refreshMarkerDots(root, player) {
    if (!player) return;

    var overlay = ensureMarkerOverlay(root);
    if (!overlay) return;

    overlay.innerHTML = '';

    var duration = Number(player.getDuration());
    if (!Number.isFinite(duration) || duration <= 0) return;

    sortLiveMarkerRows(root);

    root.querySelectorAll('[data-ti-marker-row]').forEach(function (row, index) {
      var timeInput = row.querySelector('[data-ti-marker-time]');
      var timestampMs = parseMarkerTime(timeInput && timeInput.value);
      var pct = Math.max(0, Math.min(100, (timestampMs / (duration * 1000)) * 100));

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ti-workspace__marker-dot';
      dot.textContent = String(index + 1);
      dot.setAttribute('aria-label', 'Jump to feedback point ' + String(index + 1));
      dot.style.left = pct + '%';
      dot.style.pointerEvents = 'auto';
      dot.style.border = '0';
      dot.style.cursor = 'pointer';

      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        player.seekTo(Math.max(0, Math.min(1, timestampMs / (duration * 1000))));
      });

      overlay.appendChild(dot);
    });
  }

  function markerPayload(root, row, submissionId, player) {
    var time = row.querySelector('[data-ti-marker-time]');
    var category = row.querySelector('[data-ti-marker-category]');
    var heading = row.querySelector('[data-ti-marker-heading]');
    var feedback = row.querySelector('[data-ti-marker-feedback]');

    var timestampMs = parseMarkerTime(time && time.value);
    var durationMs = player && player.getDuration() ? Math.round(player.getDuration() * 1000) : null;

    if (durationMs && timestampMs > durationMs) {
      timestampMs = durationMs;
      if (time) time.value = markerTimeInput(timestampMs);
    }

    return {
      marker_id: row.dataset.tiMarkerId || undefined,
      submission_id: submissionId,
      marker_number: Number(row.dataset.tiMarkerNumber || 1),
      timestamp_ms: timestampMs,
      category: category ? category.value : null,
      title: heading ? heading.value.trim() : null,
      feedback: feedback ? feedback.value.trim() : ''
    };
  }

  async function saveLiveMarker(root, row, submissionId, player) {
    if (!row || row.dataset.tiMarkerSaving === 'true') {
      row.dataset.tiMarkerDirty = 'true';
      return;
    }

    row.dataset.tiMarkerSaving = 'true';
    row.dataset.tiMarkerDirty = 'false';
    markerRowStatus(row, 'Saving…');

    try {
      var response = await reviewerApi('upsert_marker', markerPayload(root, row, submissionId, player));

      if (!response || !response.marker) {
        throw new Error('Marker was not returned after saving.');
      }

      row.dataset.tiMarkerId = response.marker.id;
      row.dataset.tiMarkerSaving = 'false';
      markerRowStatus(row, 'Saved');
      refreshMarkerDots(root, player);

      if (row.dataset.tiMarkerDirty === 'true') {
        row.dataset.tiMarkerDirty = 'false';
        window.setTimeout(function () {
          saveLiveMarker(root, row, submissionId, player);
        }, 100);
      }
    } catch (error) {
      row.dataset.tiMarkerSaving = 'false';
      markerRowStatus(row, error && error.message ? error.message : String(error), true);
      console.error('[Track Insight marker save]', error);
    }
  }

  async function addLiveMarker(root, submissionId, player) {
    if (!player) return;

    var timestampMs = Math.max(0, Math.round(player.getCurrentTime() * 1000));
    var row = makeLiveMarkerRow(root, {
      timestamp_ms: timestampMs,
      category: '',
      title: '',
      feedback: ''
    });

    if (!row) return;

    refreshMarkerDots(root, player);
    await saveLiveMarker(root, row, submissionId, player);

    var heading = row.querySelector('[data-ti-marker-heading]');
    if (heading) heading.focus();
  }

  async function loadLiveMarkers(root, submissionId, player) {
    var response = await reviewerApi('get_report', {
      submission_id: submissionId
    });

    var list = root.querySelector('[data-ti-marker-list]');
    if (!list) return;

    list.innerHTML = '';

    var markers = response && response.report && Array.isArray(response.report.markers)
      ? response.report.markers.slice()
      : [];

    markers.sort(function (a, b) {
      return Number(a.timestamp_ms || 0) - Number(b.timestamp_ms || 0);
    });

    markers.forEach(function (marker) {
      makeLiveMarkerRow(root, marker);
    });

    refreshMarkerDots(root, player);
  }

  function bindLiveMarkers(root, submissionId, player) {
    var addMarker = root.querySelector('[data-ti-add-marker]');
    var addRow = root.querySelector('[data-ti-add-marker-row]');
    var saveTimers = new WeakMap();

    function interceptAdd(button) {
      if (!button) return;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        addLiveMarker(root, submissionId, player);
      }, true);
    }

    interceptAdd(addMarker);
    interceptAdd(addRow);

    root.addEventListener('click', function (event) {
      var del = event.target.closest('[data-ti-delete-marker]');
      if (!del) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var row = del.closest('[data-ti-marker-row]');
      if (!row) return;

      var markerId = row.dataset.tiMarkerId;
      del.disabled = true;

      (async function () {
        try {
          if (markerId) {
            await reviewerApi('delete_marker', {
              marker_id: markerId
            });
          }

          row.remove();
          renumberLiveMarkers(root);
          refreshMarkerDots(root, player);
        } catch (error) {
          del.disabled = false;
          markerRowStatus(row, error && error.message ? error.message : String(error), true);
          console.error('[Track Insight marker delete]', error);
        }
      })();
    }, true);

    function queueSave(row, delay) {
      var previous = saveTimers.get(row);
      if (previous) window.clearTimeout(previous);

      var timer = window.setTimeout(function () {
        saveTimers.delete(row);
        saveLiveMarker(root, row, submissionId, player);
      }, delay == null ? 650 : delay);

      saveTimers.set(row, timer);
      markerRowStatus(row, 'Unsaved changes');
    }

    root.addEventListener('input', function (event) {
      var field = event.target.closest(
        '[data-ti-marker-time], [data-ti-marker-category], [data-ti-marker-heading], [data-ti-marker-feedback]'
      );
      if (!field) return;

      var row = field.closest('[data-ti-marker-row]');
      if (!row) return;

      if (field.hasAttribute('data-ti-marker-time')) {
        refreshMarkerDots(root, player);
      }

      /*
        Do not save while the reviewer is actively typing.
        This avoids interrupting focus/scroll position mid-sentence.
        The row is saved on change/blur instead.
      */
      markerRowStatus(row, 'Unsaved changes');
    });

    root.addEventListener('change', function (event) {
      var field = event.target.closest(
        '[data-ti-marker-time], [data-ti-marker-category], [data-ti-marker-heading], [data-ti-marker-feedback]'
      );
      if (!field) return;

      var row = field.closest('[data-ti-marker-row]');
      if (!row) return;

      queueSave(row, 100);
    });
  }


  /* -----------------------------------------
     LIVE PRODUCTION PROFILE SCORES
  ----------------------------------------- */

  var SCORE_FIELD_MAP = {
    'low-end': 'low_end_score',
    'tonal-balance': 'tonal_balance_score',
    'dynamics': 'dynamics_score',
    'stereo-image': 'stereo_image_score',
    'arrangement': 'arrangement_score',
    'energy-impact': 'energy_impact_score'
  };

  function clampScore(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) return 5;

    return Math.max(1, Math.min(10, Math.round(number)));
  }

  function setScoreOutput(range) {
    if (!range) return;

    var wrap = range.closest('.ti-workspace__score');
    if (!wrap) return;

    var output = wrap.querySelector('[data-ti-score-value]');
    if (output) output.textContent = String(clampScore(range.value));
  }

  function scoreStatusTarget(root) {
    var target = root.querySelector('[data-ti-score-save-state]');
    if (target) return target;

    var grid = root.querySelector('.ti-workspace__score-grid');
    if (!grid) return null;

    target = document.createElement('p');
    target.setAttribute('data-ti-score-save-state', '');
    target.style.margin = '12px 0 0';
    target.style.color = '#607273';
    target.style.fontSize = '9px';
    target.style.fontWeight = '800';
    target.style.letterSpacing = '.1em';
    target.style.textTransform = 'uppercase';
    grid.insertAdjacentElement('afterend', target);

    return target;
  }

  function setScoreSaveState(root, message, isError) {
    var target = scoreStatusTarget(root);
    if (!target) return;

    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function applyAssessmentScores(root, assessment) {
    if (!assessment) return;

    Object.keys(SCORE_FIELD_MAP).forEach(function (scoreKey) {
      var field = SCORE_FIELD_MAP[scoreKey];
      var value = assessment[field];

      if (value == null) return;

      var range = root.querySelector('[data-ti-score="' + scoreKey + '"]');
      if (!range) return;

      range.value = String(clampScore(value));
      setScoreOutput(range);
    });
  }

  function buildAssessmentPayload(root, submissionId, assessmentCache) {
    var payload = {
      submission_id: submissionId,
      overall_summary:
        assessmentCache && assessmentCache.overall_summary != null
          ? assessmentCache.overall_summary
          : null
    };

    Object.keys(SCORE_FIELD_MAP).forEach(function (scoreKey) {
      var field = SCORE_FIELD_MAP[scoreKey];
      var range = root.querySelector('[data-ti-score="' + scoreKey + '"]');

      if (range) {
        payload[field] = clampScore(range.value);
      }
    });

    return payload;
  }

  async function loadLiveAssessment(root, submissionId) {
    var response = await reviewerApi('get_report', {
      submission_id: submissionId
    });

    var assessment = response && response.report
      ? response.report.assessment
      : null;

    if (assessment) {
      applyAssessmentScores(root, assessment);
      setScoreSaveState(root, 'Saved production profile loaded');
    } else {
      setScoreSaveState(root, 'Adjust a score to save the production profile');
    }

    return assessment || null;
  }

  function bindLiveAssessment(root, submissionId, initialAssessment) {
    var ranges = Array.prototype.slice.call(
      root.querySelectorAll('[data-ti-score]')
    );

    if (!ranges.length) return;

    var assessmentCache = initialAssessment || null;
    var saveTimer = null;
    var saving = false;
    var dirty = false;

    ranges.forEach(function (range) {
      setScoreOutput(range);
    });

    async function saveScores() {
      if (saving) {
        dirty = true;
        return;
      }

      saving = true;
      dirty = false;
      setScoreSaveState(root, 'Saving production profile…');

      try {
        var payload = buildAssessmentPayload(
          root,
          submissionId,
          assessmentCache
        );

        await reviewerApi('update_assessment', payload);

        assessmentCache = Object.assign({}, assessmentCache || {}, payload);
        setScoreSaveState(root, 'Production profile saved');
      } catch (error) {
        console.error('[Track Insight production profile save]', error);
        setScoreSaveState(
          root,
          error && error.message ? error.message : String(error),
          true
        );
      } finally {
        saving = false;

        if (dirty) {
          dirty = false;
          window.setTimeout(saveScores, 120);
        }
      }
    }

    function scheduleSave(range) {
      setScoreOutput(range);
      setScoreSaveState(root, 'Unsaved score changes');

      if (saveTimer) {
        window.clearTimeout(saveTimer);
      }

      saveTimer = window.setTimeout(function () {
        saveTimer = null;
        saveScores();
      }, 450);
    }

    ranges.forEach(function (range) {
      range.addEventListener('input', function () {
        scheduleSave(range);
      });

      range.addEventListener('change', function () {
        scheduleSave(range);
      });
    });
  }


  /* -----------------------------------------
     LIVE STRENGTHS & PRIORITIES
  ----------------------------------------- */

  function unpackAssessmentItem(content) {
    var text = content == null ? '' : String(content);
    var splitAt = text.indexOf('\n');

    if (splitAt === -1) {
      return {
        heading: '',
        copy: text
      };
    }

    return {
      heading: text.slice(0, splitAt),
      copy: text.slice(splitAt + 1)
    };
  }

  function packAssessmentItem(heading, copy) {
    var cleanHeading = String(heading || '').trim();
    var cleanCopy = String(copy || '').trim();

    if (!cleanHeading && !cleanCopy) return null;

    return cleanHeading + '\n' + cleanCopy;
  }

  function strengthsPrioritiesStatusTarget(root) {
    var target = root.querySelector('[data-ti-sp-save-state]');
    if (target) return target;

    var firstStrength = root.querySelector('[data-ti-strength-heading]');
    if (!firstStrength) return null;

    var section = firstStrength.closest('.ti-workspace__section');
    if (!section) return null;

    var grid = section.querySelector('.ti-workspace__two-col');
    if (!grid) return null;

    target = document.createElement('p');
    target.setAttribute('data-ti-sp-save-state', '');
    target.style.margin = '12px 0 0';
    target.style.color = '#607273';
    target.style.fontSize = '9px';
    target.style.fontWeight = '800';
    target.style.letterSpacing = '.1em';
    target.style.textTransform = 'uppercase';
    grid.insertAdjacentElement('afterend', target);

    return target;
  }

  function setStrengthsPrioritiesSaveState(root, message, isError) {
    var target = strengthsPrioritiesStatusTarget(root);
    if (!target) return;

    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function applyStrengthsPriorities(root, strengths, priorities) {
    var strengthRows = Array.isArray(strengths) ? strengths : [];
    var priorityRows = Array.isArray(priorities) ? priorities : [];

    for (var i = 1; i <= 3; i += 1) {
      var strength = strengthRows[i - 1] || null;
      var priority = priorityRows[i - 1] || null;

      var strengthHeading = root.querySelector('[data-ti-strength-heading="' + i + '"]');
      var strengthCopy = root.querySelector('[data-ti-strength-copy="' + i + '"]');
      var priorityHeading = root.querySelector('[data-ti-priority-heading="' + i + '"]');
      var priorityCopy = root.querySelector('[data-ti-priority-copy="' + i + '"]');

      var unpackedStrength = unpackAssessmentItem(strength && strength.content);
      var unpackedPriority = unpackAssessmentItem(priority && priority.content);

      if (strengthHeading) strengthHeading.value = unpackedStrength.heading;
      if (strengthCopy) strengthCopy.value = unpackedStrength.copy;
      if (priorityHeading) priorityHeading.value = unpackedPriority.heading;
      if (priorityCopy) priorityCopy.value = unpackedPriority.copy;
    }
  }

  function collectStrengthsPriorities(root) {
    var strengths = [];
    var priorities = [];

    for (var i = 1; i <= 3; i += 1) {
      var strengthHeading = root.querySelector('[data-ti-strength-heading="' + i + '"]');
      var strengthCopy = root.querySelector('[data-ti-strength-copy="' + i + '"]');
      var priorityHeading = root.querySelector('[data-ti-priority-heading="' + i + '"]');
      var priorityCopy = root.querySelector('[data-ti-priority-copy="' + i + '"]');

      var packedStrength = packAssessmentItem(
        strengthHeading ? strengthHeading.value : '',
        strengthCopy ? strengthCopy.value : ''
      );

      var packedPriority = packAssessmentItem(
        priorityHeading ? priorityHeading.value : '',
        priorityCopy ? priorityCopy.value : ''
      );

      if (packedStrength) strengths.push(packedStrength);
      if (packedPriority) priorities.push(packedPriority);
    }

    return {
      strengths: strengths,
      priorities: priorities
    };
  }

  async function loadLiveStrengthsPriorities(root, submissionId) {
    var response = await reviewerApi('get_report', {
      submission_id: submissionId
    });

    var report = response && response.report ? response.report : {};
    var strengths = Array.isArray(report.strengths) ? report.strengths : [];
    var priorities = Array.isArray(report.priorities) ? report.priorities : [];

    applyStrengthsPriorities(root, strengths, priorities);

    if (strengths.length || priorities.length) {
      setStrengthsPrioritiesSaveState(root, 'Saved strengths & priorities loaded');
    } else {
      setStrengthsPrioritiesSaveState(root, 'Add a strength or priority to save');
    }

    return {
      assessment: report.assessment || null,
      strengths: strengths,
      priorities: priorities
    };
  }

  function bindLiveStrengthsPriorities(root, submissionId, initialAssessment) {
    var fields = Array.prototype.slice.call(
      root.querySelectorAll(
        '[data-ti-strength-heading], [data-ti-strength-copy], [data-ti-priority-heading], [data-ti-priority-copy]'
      )
    );

    if (!fields.length) return;

    var assessmentCache = initialAssessment || null;
    var saveTimer = null;
    var saving = false;
    var dirty = false;

    async function saveStrengthsPriorities() {
      if (saving) {
        dirty = true;
        return;
      }

      saving = true;
      dirty = false;
      setStrengthsPrioritiesSaveState(root, 'Saving strengths & priorities…');

      try {
        var payload = buildAssessmentPayload(
          root,
          submissionId,
          assessmentCache
        );

        var values = collectStrengthsPriorities(root);
        payload.strengths = values.strengths;
        payload.priorities = values.priorities;

        await reviewerApi('update_assessment', payload);

        assessmentCache = Object.assign({}, assessmentCache || {}, payload);
        setStrengthsPrioritiesSaveState(root, 'Strengths & priorities saved');
      } catch (error) {
        console.error('[Track Insight strengths/priorities save]', error);
        setStrengthsPrioritiesSaveState(
          root,
          error && error.message ? error.message : String(error),
          true
        );
      } finally {
        saving = false;

        if (dirty) {
          dirty = false;
          window.setTimeout(saveStrengthsPriorities, 120);
        }
      }
    }

    function scheduleSave() {
      setStrengthsPrioritiesSaveState(root, 'Unsaved strengths & priorities');

      if (saveTimer) {
        window.clearTimeout(saveTimer);
      }

      saveTimer = window.setTimeout(function () {
        saveTimer = null;
        saveStrengthsPriorities();
      }, 550);
    }

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        setStrengthsPrioritiesSaveState(root, 'Unsaved strengths & priorities');
      });
      field.addEventListener('change', scheduleSave);
    });
  }


  /* -----------------------------------------
     TRACK DIAGNOSTICS
     Tonal Balance position + Musical Effectiveness scores
  ----------------------------------------- */

  var TONAL_KEYS = [
    { key: 'Sub', label: 'Sub' },
    { key: 'Bass', label: 'Bass' },
    { key: 'Low Mids', label: 'Low Mids' },
    { key: 'Mids', label: 'Mids' },
    { key: 'High Mids', label: 'High Mids' },
    { key: 'Highs', label: 'Highs' }
  ];

  var MUSICAL_KEYS = [
    { key: 'ideas', label: 'Ideas' },
    { key: 'melody', label: 'Melody' },
    { key: 'energy', label: 'Energy' },
    { key: 'memorability', label: 'Memorability' },
    { key: 'structure', label: 'Structure' },
    { key: 'drop_impact', label: 'Drop Impact' }
  ];

  function clampTonalPosition(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) return 0;

    return Math.max(-2, Math.min(2, Math.round(number)));
  }

  function legacyTonalScoreToPosition(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) return 0;

    number = Math.max(1, Math.min(10, Math.round(number)));

    if (number <= 2) return -2;
    if (number <= 4) return -1;
    if (number <= 6) return 0;
    if (number <= 8) return 1;
    return 2;
  }

  function tonalPositionLabel(value) {
    switch (clampTonalPosition(value)) {
      case -2: return 'Too Low';
      case -1: return 'Slightly Low';
      case 1: return 'Slightly High';
      case 2: return 'Too High';
      default: return 'Balanced';
    }
  }

  function normaliseText(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function exactTextElements(scope, textValue) {
    var wanted = normaliseText(textValue);

    return Array.prototype.slice.call(scope.querySelectorAll('*')).filter(function (element) {
      return normaliseText(element.textContent) === wanted;
    });
  }

  function replaceExactText(scope, fromText, toText, preferLast) {
    var matches = exactTextElements(scope, fromText);
    if (!matches.length) return null;

    var target = preferLast ? matches[matches.length - 1] : matches[0];
    target.textContent = toText;
    return target;
  }

  function findWorkspaceSection(root, titleText) {
    var sections = Array.prototype.slice.call(root.querySelectorAll('.ti-workspace__section'));
    var wanted = normaliseText(titleText);

    return sections.find(function (section) {
      return normaliseText(section.textContent).indexOf(wanted) !== -1;
    }) || null;
  }

  function findRangeRow(range, oldLabel, section) {
    var node = range ? range.parentElement : null;

    while (node && node !== section) {
      var ranges = node.querySelectorAll('input[type="range"]');
      var labels = exactTextElements(node, oldLabel);

      if (ranges.length === 1 && labels.length) {
        return node;
      }

      node = node.parentElement;
    }

    return range ? range.parentElement : null;
  }

  function diagnosticsStatusTarget(section) {
    var target = section.querySelector('[data-ti-diagnostics-save-state]');
    if (target) return target;

    target = document.createElement('p');
    target.setAttribute('data-ti-diagnostics-save-state', '');
    target.style.margin = '12px 0 0';
    target.style.color = '#607273';
    target.style.fontSize = '9px';
    target.style.fontWeight = '800';
    target.style.letterSpacing = '.1em';
    target.style.textTransform = 'uppercase';

    section.appendChild(target);
    return target;
  }

  function setDiagnosticsState(section, message, isError) {
    var target = diagnosticsStatusTarget(section);
    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function setDiagnosticRangeOutput(range) {
    if (!range) return;

    var row = range.closest('.ti-workspace__diag-row');
    if (!row) return;

    var output = row.querySelector('[data-ti-range-output]');
    if (!output) return;

    if (range.hasAttribute('data-ti-tonal-diagnostic')) {
      var label = tonalPositionLabel(range.value);

      /*
        Tonal labels are words rather than single-digit scores, so give the
        output its own proper column instead of allowing it to overflow into
        the Musical Effectiveness side of the diagnostics grid.
      */
      row.style.gridTemplateColumns = '96px minmax(0, 1fr) 108px';
      row.style.columnGap = '12px';

      output.textContent = label;
      output.style.minWidth = '0';
      output.style.width = 'auto';
      output.style.maxWidth = '108px';
      output.style.paddingRight = '10px';
      output.style.boxSizing = 'border-box';
      output.style.fontSize = '8px';
      output.style.letterSpacing = '.04em';
      output.style.whiteSpace = 'nowrap';
      output.style.textAlign = 'right';
      output.style.textTransform = 'uppercase';

      range.setAttribute('aria-valuetext', label);
      return;
    }

    output.textContent = String(clampScore(range.value));
    range.removeAttribute('aria-valuetext');
  }

  function prepareDiagnosticsSection(root) {
    var section = findWorkspaceSection(root, 'Mix Diagnostics');
    if (!section) {
      section = findWorkspaceSection(root, 'Track Diagnostics');
    }
    if (!section) return null;

    replaceExactText(section, 'Mix Diagnostics', 'Track Diagnostics', false);
    replaceExactText(section, 'Stereo Width', 'Musical Effectiveness', true);
    replaceExactText(section, 'Diagnostic Note', 'Track Diagnostic Summary', false);

    var ranges = Array.prototype.slice.call(section.querySelectorAll('input[type="range"]'));
    if (ranges.length < 12) return null;

    var tonalRanges = ranges.slice(0, 6);
    var musicalRanges = ranges.slice(6, 12);

    TONAL_KEYS.forEach(function (item, index) {
      var range = tonalRanges[index];
      if (!range) return;

      range.setAttribute('data-ti-tonal-diagnostic', item.key);
      range.removeAttribute('data-ti-musical-diagnostic');
      range.min = '-2';
      range.max = '2';
      range.step = '1';

      /*
        Do not use a /10 score for tonal balance.
        The five positions are:
        -2 Too Low, -1 Slightly Low, 0 Balanced,
         1 Slightly High, 2 Too High.
      */
      // New reviews begin at the neutral centre position.
      // Saved values are applied immediately afterwards by loadLiveDiagnostics().
      range.value = '0';

      setDiagnosticRangeOutput(range);
    });

    var oldStereoLabels = ['Sub', 'Bass', 'Low Mids', 'Mids', 'High Mids', 'Highs'];

    MUSICAL_KEYS.forEach(function (item, index) {
      var range = musicalRanges[index];
      if (!range) return;

      range.setAttribute('data-ti-musical-diagnostic', item.key);
      range.removeAttribute('data-ti-tonal-diagnostic');
      range.min = '1';
      range.max = '10';
      range.step = '1';

      var row = findRangeRow(range, oldStereoLabels[index], section);
      if (row) {
        replaceExactText(row, oldStereoLabels[index], item.label, true);
      }

      setDiagnosticRangeOutput(range);
    });

    var summary = section.querySelector('textarea');
    if (summary) {
      summary.setAttribute('data-ti-diagnostic-summary', '');
      summary.placeholder = 'Summarise the main technical and musical picture for the customer';
    }

    return {
      section: section,
      tonalRanges: tonalRanges,
      musicalRanges: musicalRanges,
      summary: summary
    };
  }

  function applyTonalDiagnosticRange(range, value, legacy) {
    if (!range || value == null) return;

    var position = legacy
      ? legacyTonalScoreToPosition(value)
      : clampTonalPosition(value);

    range.value = String(position);
    setDiagnosticRangeOutput(range);

    try {
      range.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (_) {}
  }

  function applyMusicalDiagnosticRange(range, value) {
    if (!range || value == null) return;

    range.value = String(clampScore(value));
    setDiagnosticRangeOutput(range);

    try {
      range.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (_) {}
  }

  function collectDiagnostics(prepared) {
    return {
      tonal_balance: TONAL_KEYS.map(function (item, index) {
        return {
          band: item.key,
          value: clampTonalPosition(prepared.tonalRanges[index].value)
        };
      }),
      musical_effectiveness: MUSICAL_KEYS.map(function (item, index) {
        return {
          metric: item.key,
          value: clampScore(prepared.musicalRanges[index].value)
        };
      }),
      diagnostic_summary: prepared.summary ? prepared.summary.value : ''
    };
  }

  async function loadLiveDiagnostics(root, submissionId) {
    var prepared = prepareDiagnosticsSection(root);
    if (!prepared) return null;

    var response = await diagnosticsApi('get_diagnostics', {
      submission_id: submissionId
    });

    var tonalRows = Array.isArray(response.tonal_balance)
      ? response.tonal_balance
      : [];

    /*
      Existing test reviews may still contain the original 1–10 tonal scores.
      If any tonal point is above 2, treat that saved set as legacy and map:
      1–2 Too Low, 3–4 Slightly Low, 5–6 Balanced,
      7–8 Slightly High, 9–10 Too High.
    */
    var tonalIsLegacy = tonalRows.some(function (item) {
      return Number(item && item.value) > 2;
    });

    var tonalMap = {};
    tonalRows.forEach(function (item) {
      tonalMap[String(item.band || '')] = item.value;
    });

    var musicalMap = {};
    (response.musical_effectiveness || []).forEach(function (item) {
      musicalMap[String(item.metric || '')] = item.value;
    });

    TONAL_KEYS.forEach(function (item, index) {
      if (tonalMap[item.key] != null) {
        applyTonalDiagnosticRange(
          prepared.tonalRanges[index],
          tonalMap[item.key],
          tonalIsLegacy
        );
      }
    });

    MUSICAL_KEYS.forEach(function (item, index) {
      if (musicalMap[item.key] != null) {
        applyMusicalDiagnosticRange(
          prepared.musicalRanges[index],
          musicalMap[item.key]
        );
      }
    });

    if (prepared.summary && response.assessment && response.assessment.diagnostic_summary != null) {
      prepared.summary.value = response.assessment.diagnostic_summary;
    }

    if (tonalRows.length || (response.musical_effectiveness || []).length) {
      setDiagnosticsState(prepared.section, 'Saved track diagnostics loaded');
    } else {
      setDiagnosticsState(prepared.section, 'Adjust a diagnostic value to save');
    }

    prepared.backend = response;
    return prepared;
  }

  function bindLiveDiagnostics(root, submissionId, prepared) {
    if (!prepared) return;

    var saveTimer = null;
    var saving = false;
    var dirty = false;

    async function save() {
      if (saving) {
        dirty = true;
        return;
      }

      saving = true;
      dirty = false;
      setDiagnosticsState(prepared.section, 'Saving track diagnostics…');

      try {
        var payload = collectDiagnostics(prepared);
        payload.submission_id = submissionId;

        await diagnosticsApi('save_diagnostics', payload);
        setDiagnosticsState(prepared.section, 'Track diagnostics saved');
      } catch (error) {
        console.error('[Track Insight diagnostics save]', error);
        setDiagnosticsState(
          prepared.section,
          error && error.message ? error.message : String(error),
          true
        );
      } finally {
        saving = false;

        if (dirty) {
          dirty = false;
          window.setTimeout(save, 100);
        }
      }
    }

    function scheduleSave(range) {
      setDiagnosticRangeOutput(range);
      setDiagnosticsState(prepared.section, 'Unsaved diagnostic changes');

      if (saveTimer) {
        window.clearTimeout(saveTimer);
      }

      saveTimer = window.setTimeout(function () {
        saveTimer = null;
        save();
      }, 500);
    }

    prepared.tonalRanges
      .concat(prepared.musicalRanges)
      .forEach(function (range) {
        range.addEventListener('input', function () {
          scheduleSave(range);
        });

        range.addEventListener('change', function () {
          scheduleSave(range);
        });
      });

    if (prepared.summary) {
      prepared.summary.addEventListener('input', function () {
        setDiagnosticsState(prepared.section, 'Unsaved diagnostic changes');
      });
      prepared.summary.addEventListener('change', function () {
        scheduleSave(null);
      });
    }
  }


  /* -----------------------------------------
     DYNAMIC RECOMMENDATIONS
  ----------------------------------------- */

  function recommendationStatusTarget(section) {
    var target = section.querySelector('[data-ti-recommendations-save-state]');
    if (target) return target;

    target = document.createElement('p');
    target.setAttribute('data-ti-recommendations-save-state', '');
    target.style.margin = '12px 0 0';
    target.style.color = '#607273';
    target.style.fontSize = '9px';
    target.style.fontWeight = '800';
    target.style.letterSpacing = '.1em';
    target.style.textTransform = 'uppercase';

    section.appendChild(target);
    return target;
  }

  function setRecommendationsState(section, message, isError) {
    var target = recommendationStatusTarget(section);
    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function recommendationIssueInputs(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('input[type="text"], input:not([type])')
    );
  }

  function findRecommendationRow(input, section) {
    var node = input ? input.parentElement : null;

    while (node && node !== section) {
      var issueInputs = node.querySelectorAll('input[type="text"], input:not([type])');
      var textareas = node.querySelectorAll('textarea');

      if (issueInputs.length === 1 && textareas.length >= 2) {
        return node;
      }

      node = node.parentElement;
    }

    return input ? input.parentElement : null;
  }

  function uniqueRecommendationRows(section) {
    var rows = [];

    recommendationIssueInputs(section).forEach(function (input) {
      var row = findRecommendationRow(input, section);

      if (row && rows.indexOf(row) === -1) {
        rows.push(row);
      }
    });

    return rows;
  }

  function tagRecommendationRow(row, index) {
    if (!row) return;

    row.setAttribute('data-ti-recommendation-row', '');

    var input = row.querySelector('input[type="text"], input:not([type])');
    var textareas = Array.prototype.slice.call(row.querySelectorAll('textarea'));

    if (input) input.setAttribute('data-ti-recommendation-issue', '');
    if (textareas[0]) textareas[0].setAttribute('data-ti-recommendation-why', '');
    if (textareas[1]) textareas[1].setAttribute('data-ti-recommendation-action', '');

    var numberMatches = Array.prototype.slice.call(row.querySelectorAll('*')).filter(function (element) {
      return /^\d{2}$/.test(String(element.textContent || '').trim());
    });

    if (numberMatches.length) {
      numberMatches[0].textContent = String(index + 1).padStart(2, '0');
    }
  }

  function clearRecommendationRow(row) {
    if (!row) return;

    var fields = row.querySelectorAll('input, textarea');
    fields.forEach(function (field) {
      field.value = '';
      field.removeAttribute('id');
    });

    row.querySelectorAll('label[for]').forEach(function (label) {
      label.removeAttribute('for');
    });

    row.removeAttribute('data-ti-recommendation-row');
    row.querySelectorAll('[data-ti-recommendation-issue], [data-ti-recommendation-why], [data-ti-recommendation-action]').forEach(function (field) {
      field.removeAttribute('data-ti-recommendation-issue');
      field.removeAttribute('data-ti-recommendation-why');
      field.removeAttribute('data-ti-recommendation-action');
    });
  }

  function createAddRecommendationButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-ti-add-recommendation', '');
    button.textContent = '+ ADD RECOMMENDATION';
    button.style.marginTop = '14px';
    button.style.minHeight = '34px';
    button.style.padding = '0 15px';
    button.style.border = '1px solid #022B2D';
    button.style.background = 'transparent';
    button.style.color = '#022B2D';
    button.style.fontFamily = 'Inter, sans-serif';
    button.style.fontSize = '9px';
    button.style.fontWeight = '850';
    button.style.letterSpacing = '.08em';
    button.style.textTransform = 'uppercase';
    button.style.cursor = 'pointer';
    return button;
  }

  function prepareRecommendationsSection(root) {
    var section = findWorkspaceSection(root, 'Our Recommendations');
    if (!section) return null;

    var rows = uniqueRecommendationRows(section);
    if (!rows.length) return null;

    rows.forEach(function (row, index) {
      tagRecommendationRow(row, index);
    });

    var template = rows[0].cloneNode(true);
    clearRecommendationRow(template);

    var allTextareas = Array.prototype.slice.call(section.querySelectorAll('textarea'));
    var overallDirection = allTextareas.length ? allTextareas[allTextareas.length - 1] : null;

    if (overallDirection) {
      overallDirection.setAttribute('data-ti-overall-direction', '');
    }

    var addButton = section.querySelector('[data-ti-add-recommendation]');
    if (!addButton) {
      addButton = createAddRecommendationButton();
      rows[rows.length - 1].insertAdjacentElement('afterend', addButton);
    }

    return {
      section: section,
      rows: rows,
      template: template,
      addButton: addButton,
      overallDirection: overallDirection
    };
  }

  function allRecommendationRows(prepared) {
    return Array.prototype.slice.call(
      prepared.section.querySelectorAll('[data-ti-recommendation-row]')
    );
  }

  function addRecommendationRow(prepared) {
    var rows = allRecommendationRows(prepared);
    var row = prepared.template.cloneNode(true);
    clearRecommendationRow(row);
    tagRecommendationRow(row, rows.length);

    var anchor = prepared.addButton;
    anchor.parentNode.insertBefore(row, anchor);

    return row;
  }

  function setRecommendationRowValues(row, item) {
    if (!row) return;

    var issue = row.querySelector('[data-ti-recommendation-issue]');
    var why = row.querySelector('[data-ti-recommendation-why]');
    var action = row.querySelector('[data-ti-recommendation-action]');

    if (issue) issue.value = item && item.issue ? item.issue : '';
    if (why) why.value = item && item.why_it_matters ? item.why_it_matters : '';
    if (action) action.value = item && item.action ? item.action : '';
  }

  function collectRecommendations(prepared) {
    return allRecommendationRows(prepared)
      .map(function (row) {
        var issue = row.querySelector('[data-ti-recommendation-issue]');
        var why = row.querySelector('[data-ti-recommendation-why]');
        var action = row.querySelector('[data-ti-recommendation-action]');

        return {
          issue: issue ? issue.value.trim() : '',
          why_it_matters: why ? why.value.trim() : '',
          action: action ? action.value.trim() : ''
        };
      })
      .filter(function (item) {
        return item.issue || item.why_it_matters || item.action;
      });
  }

  async function loadLiveRecommendations(root, submissionId, diagnosticsResponse) {
    var prepared = prepareRecommendationsSection(root);
    if (!prepared) return null;

    var response = diagnosticsResponse && diagnosticsResponse.backend
      ? diagnosticsResponse.backend
      : await diagnosticsApi('get_diagnostics', { submission_id: submissionId });

    var saved = Array.isArray(response.recommendations)
      ? response.recommendations
      : [];

    var minimumRows = Math.max(3, saved.length);

    while (allRecommendationRows(prepared).length < minimumRows) {
      addRecommendationRow(prepared);
    }

    allRecommendationRows(prepared).forEach(function (row, index) {
      tagRecommendationRow(row, index);
      setRecommendationRowValues(row, saved[index] || null);
    });

    if (
      prepared.overallDirection &&
      response.assessment &&
      response.assessment.overall_direction != null
    ) {
      prepared.overallDirection.value = response.assessment.overall_direction;
    }

    if (saved.length || (prepared.overallDirection && prepared.overallDirection.value.trim())) {
      setRecommendationsState(prepared.section, 'Saved recommendations loaded');
    } else {
      setRecommendationsState(prepared.section, 'Add recommendations as needed');
    }

    return prepared;
  }

  function bindLiveRecommendations(root, submissionId, prepared) {
    if (!prepared) return;

    var saveTimer = null;
    var saving = false;
    var dirty = false;

    async function save() {
      if (saving) {
        dirty = true;
        return;
      }

      saving = true;
      dirty = false;
      setRecommendationsState(prepared.section, 'Saving recommendations…');

      try {
        await diagnosticsApi('save_recommendations', {
          submission_id: submissionId,
          recommendations: collectRecommendations(prepared),
          overall_direction: prepared.overallDirection
            ? prepared.overallDirection.value
            : ''
        });

        setRecommendationsState(prepared.section, 'Recommendations saved');
      } catch (error) {
        console.error('[Track Insight recommendations save]', error);
        setRecommendationsState(
          prepared.section,
          error && error.message ? error.message : String(error),
          true
        );
      } finally {
        saving = false;

        if (dirty) {
          dirty = false;
          window.setTimeout(save, 100);
        }
      }
    }

    function scheduleSave() {
      setRecommendationsState(prepared.section, 'Unsaved recommendation changes');

      if (saveTimer) {
        window.clearTimeout(saveTimer);
      }

      saveTimer = window.setTimeout(function () {
        saveTimer = null;
        save();
      }, 550);
    }

    prepared.section.addEventListener('input', function (event) {
      if (
        event.target.matches(
          '[data-ti-recommendation-issue], [data-ti-recommendation-why], [data-ti-recommendation-action], [data-ti-overall-direction]'
        )
      ) {
        /*
          Mark as unsaved while typing, but do not call the API until
          the reviewer leaves the field. This keeps typing completely stable.
        */
        setRecommendationsState(prepared.section, 'Unsaved recommendation changes');
      }
    });

    prepared.section.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '[data-ti-recommendation-issue], [data-ti-recommendation-why], [data-ti-recommendation-action], [data-ti-overall-direction]'
        )
      ) {
        scheduleSave();
      }
    });

    prepared.addButton.addEventListener('click', function () {
      var row = addRecommendationRow(prepared);
      var issue = row.querySelector('[data-ti-recommendation-issue]');

      if (issue) {
        issue.focus();
      }

      setRecommendationsState(prepared.section, 'New recommendation added');
    });
  }



  /* -----------------------------------------
     PRIVATE SECOND OPINION / AI ASSIST
  ----------------------------------------- */

  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function soElement(root, selector) {
    return root.querySelector(selector);
  }

  function setSecondOpinionStatus(root, message, isError) {
    var status = soElement(root, '[data-ti-so-status]');
    var error = soElement(root, '[data-ti-so-error]');

    if (status) {
      status.textContent = message || '';
      status.style.color = isError ? '#D67E4A' : '#B9C6C3';
    }

    if (error) {
      error.textContent = isError ? (message || '') : '';
      error.style.display = isError && message ? 'block' : 'none';
    }
  }

  function secondOpinionStatusLabel(status) {
    switch (String(status || 'not_started').toLowerCase()) {
      case 'queued': return 'Queued';
      case 'running': return 'Analysing';
      case 'complete': return 'Ready';
      case 'error': return 'Needs attention';
      default: return 'Not run';
    }
  }

  function metricDisplay(key, value) {
    var n = Number(value);
    if (!Number.isFinite(n)) return '—';

    switch (key) {
      case 'duration_seconds': return formatTime(n);
      case 'sample_rate_hz': return (n / 1000).toFixed(n % 1000 ? 1 : 0) + ' kHz';
      case 'channels': return String(Math.round(n));
      case 'peak_dbfs': return n.toFixed(1) + ' dBFS';
      case 'rms_dbfs': return n.toFixed(1) + ' dBFS';
      case 'crest_factor_db': return n.toFixed(1) + ' dB';
      case 'stereo_correlation': return n.toFixed(2);
      case 'side_to_mid_db': return n.toFixed(1) + ' dB';
      case 'analysis_mp3_bitrate_kbps': return Math.round(n) + ' kbps';
      default: return String(n);
    }
  }

  function renderSecondOpinionMetrics(root, metrics) {
    var target = soElement(root, '[data-ti-so-metrics]');
    if (!target) return;

    var defs = [
      ['peak_dbfs', 'Peak'],
      ['rms_dbfs', 'RMS'],
      ['crest_factor_db', 'Crest Factor'],
      ['stereo_correlation', 'Stereo Correlation'],
      ['side_to_mid_db', 'Side / Mid'],
      ['sample_rate_hz', 'Sample Rate'],
      ['channels', 'Channels'],
      ['duration_seconds', 'Duration']
    ];

    var available = defs.filter(function (item) {
      return metrics && Number.isFinite(Number(metrics[item[0]]));
    });

    if (!available.length) {
      target.innerHTML =
        '<div class="ti-workspace__second-opinion-metric">' +
          '<span class="ti-workspace__second-opinion-metric-label">Status</span>' +
          '<span class="ti-workspace__second-opinion-metric-value">Not analysed</span>' +
        '</div>';
      return;
    }

    target.innerHTML = available.map(function (item) {
      return (
        '<div class="ti-workspace__second-opinion-metric">' +
          '<span class="ti-workspace__second-opinion-metric-label">' + escapeHtml(item[1]) + '</span>' +
          '<span class="ti-workspace__second-opinion-metric-value">' + escapeHtml(metricDisplay(item[0], metrics[item[0]])) + '</span>' +
        '</div>'
      );
    }).join('');
  }

  function renderSecondOpinionScores(root, profile) {
    var keys = ['low_end', 'tonal_balance', 'dynamics', 'stereo_image', 'arrangement', 'energy_impact'];

    keys.forEach(function (key) {
      var node = soElement(root, '[data-ti-so-score="' + key + '"]');
      if (!node) return;

      var value = profile && Number(profile[key]);
      node.textContent = Number.isFinite(value) ? String(Math.round(value)) : '—';
    });
  }

  function renderSecondOpinionTimestamps(root, items) {
    var target = soElement(root, '[data-ti-so-timestamps]');
    if (!target) return;

    if (!Array.isArray(items) || !items.length) {
      target.innerHTML = '<p class="ti-workspace__second-opinion-empty">No timestamp suggestions were returned.</p>';
      return;
    }

    target.innerHTML = items.map(function (item) {
      var confidence = Number(item && item.confidence);
      return (
        '<article class="ti-workspace__second-opinion-item">' +
          '<div>' +
            '<div class="ti-workspace__second-opinion-item-time">' + escapeHtml(formatTime(Number(item.timestamp_seconds || 0))) + '</div>' +
            '<div class="ti-workspace__second-opinion-item-area">' + escapeHtml(item.area || 'Observation') + '</div>' +
          '</div>' +
          '<div>' +
            '<p class="ti-workspace__second-opinion-item-title">' + escapeHtml(item.observation || '') + '</p>' +
            '<p class="ti-workspace__second-opinion-item-copy">' + escapeHtml(item.recommendation || '') + '</p>' +
            (Number.isFinite(confidence)
              ? '<span class="ti-workspace__second-opinion-confidence">Confidence ' + Math.round(confidence * 100) + '%</span>'
              : '') +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function renderSecondOpinionObservations(root, items) {
    var target = soElement(root, '[data-ti-so-observations]');
    if (!target) return;

    if (!Array.isArray(items) || !items.length) {
      target.innerHTML = '<p class="ti-workspace__second-opinion-empty">No whole-track observations were returned.</p>';
      return;
    }

    target.innerHTML = items.map(function (item) {
      var confidence = Number(item && item.confidence);
      return (
        '<article class="ti-workspace__second-opinion-item">' +
          '<div class="ti-workspace__second-opinion-item-area">' + escapeHtml(item.area || 'Observation') + '</div>' +
          '<div>' +
            '<p class="ti-workspace__second-opinion-item-title">' + escapeHtml(item.observation || '') + '</p>' +
            '<p class="ti-workspace__second-opinion-item-copy">' + escapeHtml(item.recommendation || '') + '</p>' +
            (Number.isFinite(confidence)
              ? '<span class="ti-workspace__second-opinion-confidence">Confidence ' + Math.round(confidence * 100) + '%</span>'
              : '') +
          '</div>' +
        '</article>'
      );
    }).join('');
  }


  function soEmpty(target, message) {
    if (!target) return;
    target.innerHTML = '<p class="ti-workspace__second-opinion-empty">' + escapeHtml(message) + '</p>';
  }

  function renderSecondOpinionTopChecks(root, items) {
    var target = soElement(root, '[data-ti-so-top-checks]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No ranked checks were returned.');
    target.innerHTML = '<ol class="ti-workspace__second-opinion-rich-list">' + items.map(function (item, index) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">Priority ' + (index + 1) + ' · ' + escapeHtml(item.area || 'Check') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.reason || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy"><strong>Listen for:</strong> ' + escapeHtml(item.listen_for || '') + '</p>' +
      '</li>';
    }).join('') + '</ol>';
  }

  function renderSecondOpinionStrengths(root, items) {
    var target = soElement(root, '[data-ti-so-strengths]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No specific strengths were returned.');
    target.innerHTML = '<ul class="ti-workspace__second-opinion-rich-list">' + items.map(function (item) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.area || 'Strength') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.observation || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(item.why_preserve || '') + '</p>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function renderSecondOpinionPriorities(root, items) {
    var target = soElement(root, '[data-ti-so-priorities]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No additional priority fixes were returned.');
    target.innerHTML = '<ul class="ti-workspace__second-opinion-rich-list">' + items.map(function (item) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.area || 'Priority') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.issue || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(item.why_it_matters || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy"><strong>Possible action:</strong> ' + escapeHtml(item.suggested_action || '') + '</p>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function renderSecondOpinionFocus(root, focus) {
    var target = soElement(root, '[data-ti-so-focus]');
    if (!target) return;
    var defs = [
      ['low_end', 'Low end'],
      ['stereo', 'Stereo / centre'],
      ['drop_impact', 'Drop impact'],
      ['musical_effectiveness', 'Musical effectiveness']
    ];
    var available = defs.filter(function (def) {
      var value = focus && focus[def[0]];
      return value && (value.assessment || value.preserve || value.improve);
    });
    if (!available.length) return soEmpty(target, 'No focused production read was returned.');
    target.innerHTML = available.map(function (def) {
      var item = focus[def[0]] || {};
      return '<div class="ti-workspace__second-opinion-focus">' +
        '<p class="ti-workspace__second-opinion-focus-label">' + escapeHtml(def[1]) + '</p>' +
        '<p><strong>Assessment:</strong> ' + escapeHtml(item.assessment || '') + '</p>' +
        '<p><strong>Preserve:</strong> ' + escapeHtml(item.preserve || '') + '</p>' +
        '<p><strong>Improve:</strong> ' + escapeHtml(item.improve || '') + '</p>' +
      '</div>';
    }).join('');
  }

  function renderSecondOpinionSectionMap(root, items) {
    var target = soElement(root, '[data-ti-so-section-map]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No section map was returned.');
    target.innerHTML = items.map(function (item) {
      var start = Number(item.start_seconds || 0);
      var end = Number(item.end_seconds || 0);
      var energy = Number(item.energy);
      return '<div class="ti-workspace__second-opinion-section-row">' +
        '<div class="ti-workspace__second-opinion-section-meta">' + escapeHtml(item.section || 'Section') + '</div>' +
        '<div class="ti-workspace__second-opinion-section-meta">' + escapeHtml(formatTime(start)) + '–' + escapeHtml(formatTime(end)) + '</div>' +
        '<div class="ti-workspace__second-opinion-section-meta">Energy ' + (Number.isFinite(energy) ? Math.round(energy) : '—') + '/10</div>' +
        '<div><p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.observation || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(item.opportunity || '') + '</p></div>' +
      '</div>';
    }).join('');
  }

  function renderSecondOpinionHierarchy(root, items) {
    var target = soElement(root, '[data-ti-so-hierarchy]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No hierarchy or masking observations were returned.');
    target.innerHTML = '<ul class="ti-workspace__second-opinion-rich-list">' + items.map(function (item) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.element || 'Element') + ' · ' + escapeHtml(item.role || '') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.observation || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(item.suggestion || '') + '</p>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function renderSecondOpinionRisks(root, items) {
    var target = soElement(root, '[data-ti-so-risks]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No specific translation risks were returned.');
    target.innerHTML = '<ul class="ti-workspace__second-opinion-rich-list">' + items.map(function (item) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.likely_context || 'Translation check') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.risk || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy"><strong>Check:</strong> ' + escapeHtml(item.check || '') + '</p>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function renderSecondOpinionAlternatives(root, items) {
    var target = soElement(root, '[data-ti-so-alternatives]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) return soEmpty(target, 'No alternative approaches were returned.');
    target.innerHTML = '<ul class="ti-workspace__second-opinion-rich-list">' + items.map(function (item) {
      return '<li class="ti-workspace__second-opinion-rich-item">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.area || 'Alternative') + '</span>' +
        '<p class="ti-workspace__second-opinion-rich-copy"><strong>Option A:</strong> ' + escapeHtml(item.option_a || '') + '</p>' +
        '<p class="ti-workspace__second-opinion-rich-copy"><strong>Option B:</strong> ' + escapeHtml(item.option_b || '') + '</p>' +
      '</li>';
    }).join('') + '</ul>';
  }

  function renderSecondOpinionReadiness(root, item) {
    var target = soElement(root, '[data-ti-so-readiness]');
    if (!target) return;
    item = item || {};
    if (!item.level && !item.summary && !item.biggest_gap) return soEmpty(target, 'No readiness view was returned.');
    target.innerHTML =
      '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(item.level || 'Internal view') + '</span>' +
      '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.summary || '') + '</p>' +
      '<p class="ti-workspace__second-opinion-rich-copy"><strong>Biggest gap:</strong> ' + escapeHtml(item.biggest_gap || '') + '</p>';
  }

  function renderSecondOpinionReportIdeas(root, ideas) {
    var target = soElement(root, '[data-ti-so-report-ideas]');
    if (!target) return;
    ideas = ideas || {};

    function listHtml(title, items) {
      if (!Array.isArray(items) || !items.length) return '';
      return '<div class="ti-workspace__second-opinion-report-group">' +
        '<span class="ti-workspace__second-opinion-rich-label">' + escapeHtml(title) + '</span>' +
        '<ul class="ti-workspace__second-opinion-report-list">' +
          items.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') +
        '</ul></div>';
    }

    var html = '';
    html += listHtml('What to keep', ideas.strengths);
    html += listHtml('What to fix', ideas.priorities);
    html += listHtml('How the frequency sits', ideas.tonal_balance);
    html += listHtml('Stereo width', ideas.stereo_width);

    if (Array.isArray(ideas.final_recommendations) && ideas.final_recommendations.length) {
      html += '<div class="ti-workspace__second-opinion-report-group"><span class="ti-workspace__second-opinion-rich-label">How we’d fix it — candidate ideas</span>' +
        '<ul class="ti-workspace__second-opinion-rich-list">' +
        ideas.final_recommendations.map(function (item) {
          return '<li class="ti-workspace__second-opinion-rich-item">' +
            '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.issue || '') + '</p>' +
            '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(item.why_it_matters || '') + '</p>' +
            '<p class="ti-workspace__second-opinion-rich-copy"><strong>Action:</strong> ' + escapeHtml(item.action || '') + '</p>' +
          '</li>';
        }).join('') + '</ul></div>';
    }

    if (ideas.overall_direction) {
      html += '<div class="ti-workspace__second-opinion-report-group"><span class="ti-workspace__second-opinion-rich-label">Overall direction</span>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(ideas.overall_direction) + '</p></div>';
    }

    target.innerHTML = html || '<p class="ti-workspace__second-opinion-empty">No customer-report ideas were returned.</p>';
  }


  function soTextBlob(item) {
    if (!item || typeof item !== 'object') return '';
    return Object.keys(item).map(function (key) {
      var value = item[key];
      return typeof value === 'string' ? value : '';
    }).join(' ').toLowerCase();
  }

  function soMatches(item, regex) {
    return regex.test(soTextBlob(item));
  }

  function soUniqueEvidence(items) {
    var seen = {};
    return items.filter(function (item) {
      var key = String((item.title || '') + '|' + (item.copy || '') + '|' + (item.extra || ''))
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function renderSoEvidence(target, items, emptyMessage) {
    if (!target) return;
    items = soUniqueEvidence(items || []);
    if (!items.length) return soEmpty(target, emptyMessage);

    target.innerHTML = '<div class="ti-workspace__so-evidence">' + items.map(function (item) {
      return '<div class="ti-workspace__so-evidence-item">' +
        '<div class="ti-workspace__so-evidence-source">' + escapeHtml(item.source || 'Observation') + '</div>' +
        '<div>' +
          (item.title ? '<p class="ti-workspace__so-evidence-title">' + escapeHtml(item.title) + '</p>' : '') +
          (item.copy ? '<p class="ti-workspace__so-evidence-copy">' + escapeHtml(item.copy) + '</p>' : '') +
          (item.extra ? '<p class="ti-workspace__so-evidence-copy"><strong>' + escapeHtml(item.extraLabel || 'Possible action') + ':</strong> ' + escapeHtml(item.extra) + '</p>' : '') +
        '</div>' +
      '</div>';
    }).join('') + '</div>';
  }

  function renderSecondOpinionArrangementContext(root, analysis) {
    var target = soElement(root, '[data-ti-so-arrangement-context]');
    if (!target) return;

    var focus = analysis.focus_areas || {};
    var items = [];

    ['drop_impact', 'musical_effectiveness'].forEach(function (key) {
      var item = focus[key];
      if (!item) return;
      items.push({
        source: key === 'drop_impact' ? 'Drop impact' : 'Musical effectiveness',
        title: item.assessment || '',
        copy: item.preserve ? 'Preserve: ' + item.preserve : '',
        extra: item.improve || '',
        extraLabel: 'Improve'
      });
    });

    renderSoEvidence(target, items, '');
  }

  function renderSecondOpinionDiagnosticBuilder(root, analysis) {
    var frequencyTarget = soElement(root, '[data-ti-so-frequency]');
    var stereoTarget = soElement(root, '[data-ti-so-stereo]');
    var elementTarget = soElement(root, '[data-ti-so-element-balance]');
    var risksTarget = soElement(root, '[data-ti-so-general-risks]');

    var focus = analysis.focus_areas || {};
    var ideas = analysis.reviewer_report_ideas || {};
    var observations = Array.isArray(analysis.mix_observations) ? analysis.mix_observations : [];
    var hierarchy = Array.isArray(analysis.element_hierarchy) ? analysis.element_hierarchy : [];
    var risks = Array.isArray(analysis.translation_risks) ? analysis.translation_risks : [];

    var frequencyRegex = /(low[\s_-]?end|sub|bass|kick|frequency|tonal|midrange|mid range|high mids?|low mids?|harsh|bright|mud|box|thin|weight)/i;
    var stereoRegex = /(stereo|width|wide|narrow|mono|centre|center|side|mid\/side|image|spatial)/i;

    var frequency = [];
    var stereo = [];
    var generalElement = [];
    var generalRisks = [];

    if (focus.low_end) {
      frequency.push({
        source: 'Low-end assessment',
        title: focus.low_end.assessment || '',
        copy: focus.low_end.preserve ? 'Preserve: ' + focus.low_end.preserve : '',
        extra: focus.low_end.improve || '',
        extraLabel: 'Improve'
      });
    }

    if (focus.stereo) {
      stereo.push({
        source: 'Stereo / centre assessment',
        title: focus.stereo.assessment || '',
        copy: focus.stereo.preserve ? 'Preserve: ' + focus.stereo.preserve : '',
        extra: focus.stereo.improve || '',
        extraLabel: 'Improve'
      });
    }

    (ideas.tonal_balance || []).forEach(function (text) {
      frequency.push({ source: 'Customer-report idea', title: String(text || '') });
    });

    (ideas.stereo_width || []).forEach(function (text) {
      stereo.push({ source: 'Customer-report idea', title: String(text || '') });
    });

    observations.forEach(function (item) {
      var evidence = {
        source: 'Listening observation · ' + (item.area || 'Mix'),
        title: item.observation || '',
        copy: '',
        extra: item.recommendation || '',
        extraLabel: 'Possible action'
      };

      if (soMatches(item, stereoRegex)) stereo.push(evidence);
      else if (soMatches(item, frequencyRegex)) frequency.push(evidence);
      else generalElement.push(evidence);
    });

    hierarchy.forEach(function (item) {
      var evidence = {
        source: (item.element || 'Element') + (item.role ? ' · ' + item.role : ''),
        title: item.observation || '',
        copy: '',
        extra: item.suggestion || '',
        extraLabel: 'Possible action'
      };

      if (soMatches(item, stereoRegex)) stereo.push(evidence);
      else if (soMatches(item, frequencyRegex)) frequency.push(evidence);
      else generalElement.push(evidence);
    });

    risks.forEach(function (item) {
      var evidence = {
        source: item.likely_context || 'Translation check',
        title: item.risk || '',
        copy: '',
        extra: item.check || '',
        extraLabel: 'Check'
      };

      if (soMatches(item, stereoRegex)) stereo.push(evidence);
      else if (soMatches(item, frequencyRegex)) frequency.push(evidence);
      else generalRisks.push(evidence);
    });

    renderSoEvidence(frequencyTarget, frequency, 'No frequency-specific observations were returned.');
    renderSoEvidence(stereoTarget, stereo, 'No stereo-specific observations were returned.');
    renderSoEvidence(elementTarget, generalElement, 'No additional element-balance observations were returned.');
    renderSoEvidence(risksTarget, generalRisks, 'No additional translation checks were returned.');
  }

  function renderSecondOpinionRecommendationBuilder(root, analysis) {
    var target = soElement(root, '[data-ti-so-recommendation-builder]');
    if (!target) return;

    var ideas = analysis.reviewer_report_ideas || {};
    var recs = Array.isArray(ideas.final_recommendations) ? ideas.final_recommendations : [];
    var alternatives = Array.isArray(analysis.alternative_ideas) ? analysis.alternative_ideas : [];
    var html = '';

    if (recs.length) {
      html += '<div class="ti-workspace__so-evidence">' + recs.map(function (item) {
        return '<div class="ti-workspace__so-evidence-item">' +
          '<div class="ti-workspace__so-evidence-source">Candidate recommendation</div>' +
          '<div>' +
            '<p class="ti-workspace__so-evidence-title">' + escapeHtml(item.issue || '') + '</p>' +
            '<p class="ti-workspace__so-evidence-copy">' + escapeHtml(item.why_it_matters || '') + '</p>' +
            '<p class="ti-workspace__so-evidence-copy"><strong>Action:</strong> ' + escapeHtml(item.action || '') + '</p>' +
          '</div>' +
        '</div>';
      }).join('') + '</div>';
    }

    if (alternatives.length) {
      html += '<div class="ti-workspace__so-rec-direction">' +
        '<span class="ti-workspace__so-rec-direction-label">Alternative approaches</span>' +
        alternatives.map(function (item) {
          return '<div class="ti-workspace__second-opinion-rich-item">' +
            '<p class="ti-workspace__second-opinion-rich-title">' + escapeHtml(item.area || 'Alternative') + '</p>' +
            '<p class="ti-workspace__second-opinion-rich-copy"><strong>Option A:</strong> ' + escapeHtml(item.option_a || '') + '</p>' +
            '<p class="ti-workspace__second-opinion-rich-copy"><strong>Option B:</strong> ' + escapeHtml(item.option_b || '') + '</p>' +
          '</div>';
        }).join('') +
      '</div>';
    }

    if (ideas.overall_direction) {
      html += '<div class="ti-workspace__so-rec-direction">' +
        '<span class="ti-workspace__so-rec-direction-label">Overall direction</span>' +
        '<p class="ti-workspace__second-opinion-rich-copy">' + escapeHtml(ideas.overall_direction) + '</p>' +
      '</div>';
    }

    target.innerHTML = html || '<p class="ti-workspace__second-opinion-empty">No recommendation ideas were returned.</p>';
  }

  function renderSecondOpinion(root, payload) {
    payload = payload || {};
    var analysis = payload.analysis || { status: 'not_started' };
    var status = String(analysis.status || 'not_started').toLowerCase();
    var summary = soElement(root, '[data-ti-so-summary-state]');
    var runButton = soElement(root, '[data-ti-so-run]');
    var overall = soElement(root, '[data-ti-so-overall]');

    if (summary) summary.textContent = secondOpinionStatusLabel(status);

    if (runButton) {
      runButton.disabled = status === 'queued' || status === 'running';
      runButton.textContent = status === 'complete' || status === 'error'
        ? 'Run Second Opinion Again'
        : (status === 'queued' || status === 'running' ? 'Analysing…' : 'Run Second Opinion');
    }

    renderSecondOpinionMetrics(root, analysis.technical_metrics || {});
    renderSecondOpinionScores(root, analysis.production_profile || {});
    renderSecondOpinionTopChecks(root, analysis.top_checks || []);
    renderSecondOpinionStrengths(root, analysis.strengths_to_preserve || []);
    renderSecondOpinionPriorities(root, analysis.priority_fixes || []);
    renderSecondOpinionFocus(root, analysis.focus_areas || {});
    renderSecondOpinionSectionMap(root, analysis.section_map || []);
    renderSecondOpinionHierarchy(root, analysis.element_hierarchy || []);
    renderSecondOpinionRisks(root, analysis.translation_risks || []);
    renderSecondOpinionAlternatives(root, analysis.alternative_ideas || []);
    renderSecondOpinionReadiness(root, analysis.commercial_readiness || {});
    renderSecondOpinionReportIdeas(root, analysis.reviewer_report_ideas || {});
    renderSecondOpinionArrangementContext(root, analysis);
    renderSecondOpinionDiagnosticBuilder(root, analysis);
    renderSecondOpinionRecommendationBuilder(root, analysis);

    if (status === 'complete') {
      renderSecondOpinionTimestamps(root, analysis.timestamp_suggestions || []);
      renderSecondOpinionObservations(root, analysis.mix_observations || []);
      if (overall) overall.textContent = analysis.overall_notes || 'No overall note was returned.';
      setSecondOpinionStatus(root, 'Second Opinion ready — review, use or ignore anything here', false);
      return;
    }

    if (status === 'error') {
      if (overall) overall.textContent = 'The previous Second Opinion run did not complete.';
      setSecondOpinionStatus(root, analysis.error_message || 'Second Opinion analysis failed.', true);
      return;
    }

    if (status === 'queued' || status === 'running') {
      if (overall) overall.textContent = 'Analysis is running in the background. You can continue reviewing while it works.';
      setSecondOpinionStatus(
        root,
        status === 'queued' ? 'Second Opinion queued…' : 'Second Opinion is listening to the track…',
        false
      );
      return;
    }

    if (overall) overall.textContent = 'No analysis has been run yet.';
    setSecondOpinionStatus(root, 'Ready when you are', false);
  }

  function decodedBufferFromPlayer(player) {
    if (!player) return null;

    if (typeof player.getDecodedData === 'function') {
      try {
        var decoded = player.getDecodedData();
        if (decoded) return decoded;
      } catch (_) {}
    }

    if (player.backend) {
      if (player.backend.buffer) return player.backend.buffer;
      if (player.backend.decodedData) return player.backend.decodedData;
    }

    return null;
  }

  async function waitForDecodedBuffer(player, timeoutMs) {
    var started = Date.now();

    while (Date.now() - started < timeoutMs) {
      var buffer = decodedBufferFromPlayer(player);
      if (buffer && buffer.length && buffer.sampleRate) return buffer;
      await sleep(120);
    }

    throw new Error('The track is still decoding. Wait for the waveform to finish loading, then try again.');
  }

  function safeDb(value) {
    return 20 * Math.log10(Math.max(Number(value) || 0, 1e-12));
  }

  function calculateTechnicalMetrics(buffer) {
    var channelCount = Math.max(1, Math.min(2, Number(buffer.numberOfChannels || 1)));
    var left = buffer.getChannelData(0);
    var right = channelCount > 1 ? buffer.getChannelData(1) : left;
    var stride = Math.max(1, Math.floor(Number(buffer.sampleRate || 44100) / 12000));

    var peak = 0;
    var sumAudioSq = 0;
    var sumL2 = 0;
    var sumR2 = 0;
    var sumLR = 0;
    var sumMid2 = 0;
    var sumSide2 = 0;
    var count = 0;

    for (var i = 0; i < left.length; i += stride) {
      var l = left[i] || 0;
      var r = right[i] || 0;
      var absL = Math.abs(l);
      var absR = Math.abs(r);
      if (absL > peak) peak = absL;
      if (absR > peak) peak = absR;

      sumAudioSq += l * l;
      if (channelCount > 1) sumAudioSq += r * r;

      sumL2 += l * l;
      sumR2 += r * r;
      sumLR += l * r;

      var mid = (l + r) * 0.5;
      var side = (l - r) * 0.5;
      sumMid2 += mid * mid;
      sumSide2 += side * side;
      count += 1;
    }

    var rmsDenominator = Math.max(1, count * channelCount);
    var rms = Math.sqrt(sumAudioSq / rmsDenominator);
    var peakDb = safeDb(peak);
    var rmsDb = safeDb(rms);
    var corrDenominator = Math.sqrt(Math.max(sumL2 * sumR2, 1e-24));
    var corr = channelCount > 1 ? (sumLR / corrDenominator) : 1;
    corr = Math.max(-1, Math.min(1, corr));
    var sideToMid = channelCount > 1
      ? 10 * Math.log10(Math.max(sumSide2, 1e-24) / Math.max(sumMid2, 1e-24))
      : -100;

    return {
      duration_seconds: Number(buffer.duration.toFixed(3)),
      sample_rate_hz: Number(buffer.sampleRate),
      channels: channelCount,
      peak_dbfs: Number(peakDb.toFixed(3)),
      rms_dbfs: Number(rmsDb.toFixed(3)),
      crest_factor_db: Number((peakDb - rmsDb).toFixed(3)),
      stereo_correlation: Number(corr.toFixed(4)),
      side_to_mid_db: Number(Math.max(-100, Math.min(100, sideToMid)).toFixed(3)),
      analysis_mp3_bitrate_kbps: 192
    };
  }

  function loadLame() {
    if (window.lamejs && window.lamejs.Mp3Encoder) {
      return Promise.resolve(window.lamejs);
    }

    if (window.__tiSecondOpinionLamePromise) {
      return window.__tiSecondOpinionLamePromise;
    }

    window.__tiSecondOpinionLamePromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-ti-second-opinion-lame]');

      if (existing) {
        existing.addEventListener('load', function () {
          if (window.lamejs && window.lamejs.Mp3Encoder) resolve(window.lamejs);
          else reject(new Error('MP3 encoder loaded but did not initialise.'));
        }, { once: true });
        existing.addEventListener('error', function () {
          reject(new Error('MP3 encoder could not be loaded.'));
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = LAME_SRC;
      script.async = true;
      script.setAttribute('data-ti-second-opinion-lame', '');
      script.onload = function () {
        if (window.lamejs && window.lamejs.Mp3Encoder) resolve(window.lamejs);
        else reject(new Error('MP3 encoder loaded but did not initialise.'));
      };
      script.onerror = function () {
        reject(new Error('MP3 encoder could not be loaded.'));
      };
      document.head.appendChild(script);
    });

    return window.__tiSecondOpinionLamePromise;
  }

  async function resampleForMp3(buffer) {
    var supported = [32000, 44100, 48000];
    if (supported.indexOf(Number(buffer.sampleRate)) !== -1) return buffer;

    var targetRate = Number(buffer.sampleRate) > 48000 ? 48000 : 44100;
    var OfflineContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    if (!OfflineContext) {
      throw new Error('This browser cannot prepare the analysis MP3 from this sample rate.');
    }

    var channels = Math.max(1, Math.min(2, Number(buffer.numberOfChannels || 1)));
    var frameCount = Math.ceil(buffer.duration * targetRate);
    var context = new OfflineContext(channels, frameCount, targetRate);
    var source = context.createBufferSource();
    source.buffer = buffer;
    source.connect(context.destination);
    source.start(0);
    return context.startRendering();
  }

  function floatChunkToInt16(channel, start, end) {
    var result = new Int16Array(end - start);

    for (var i = start, j = 0; i < end; i += 1, j += 1) {
      var sample = Math.max(-1, Math.min(1, channel[i] || 0));
      result[j] = sample < 0 ? Math.round(sample * 32768) : Math.round(sample * 32767);
    }

    return result;
  }

  async function encodeAnalysisMp3(root, originalBuffer) {
    setSecondOpinionStatus(root, 'Preparing private analysis MP3…', false);
    await loadLame();

    var buffer = await resampleForMp3(originalBuffer);
    var channels = Math.max(1, Math.min(2, Number(buffer.numberOfChannels || 1)));
    var left = buffer.getChannelData(0);
    var right = channels > 1 ? buffer.getChannelData(1) : null;
    var encoder = new window.lamejs.Mp3Encoder(channels, Number(buffer.sampleRate), 192);
    var mp3Data = [];
    var chunkSize = 1152 * 20;
    var total = left.length;

    for (var start = 0, iteration = 0; start < total; start += chunkSize, iteration += 1) {
      var end = Math.min(total, start + chunkSize);
      var left16 = floatChunkToInt16(left, start, end);
      var encoded;

      if (channels > 1) {
        var right16 = floatChunkToInt16(right, start, end);
        encoded = encoder.encodeBuffer(left16, right16);
      } else {
        encoded = encoder.encodeBuffer(left16);
      }

      if (encoded && encoded.length) mp3Data.push(new Int8Array(encoded));

      if (iteration % 8 === 0) {
        var pct = Math.min(99, Math.round((end / total) * 100));
        setSecondOpinionStatus(root, 'Preparing private analysis MP3… ' + pct + '%', false);
        await sleep(0);
      }
    }

    var flushed = encoder.flush();
    if (flushed && flushed.length) mp3Data.push(new Int8Array(flushed));

    var blob = new Blob(mp3Data, { type: 'audio/mpeg' });
    if (!blob.size) throw new Error('The private analysis MP3 could not be created.');
    if (blob.size > 30 * 1024 * 1024) {
      throw new Error('The prepared analysis MP3 is too large.');
    }

    return blob;
  }

  async function uploadAnalysisMp3(root, submissionId, blob) {
    setSecondOpinionStatus(root, 'Uploading private analysis copy…', false);

    var info = await secondOpinionApi('get_analysis_upload_url', {
      submission_id: submissionId
    });

    if (!info || !info.signed_upload_url) {
      throw new Error('The analysis upload URL was not returned.');
    }

    var uploadUrl = new URL(info.signed_upload_url, SUPABASE_URL).toString();
    var response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'audio/mpeg'
      },
      body: blob
    });

    if (!response.ok) {
      var detail = '';
      try { detail = await response.text(); } catch (_) {}
      throw new Error('Private analysis audio upload failed (' + response.status + ')' + (detail ? ': ' + detail.slice(0, 240) : ''));
    }
  }

  async function pollSecondOpinion(root, submissionId, maxAttempts) {
    var attempts = Number(maxAttempts || 140);

    for (var i = 0; i < attempts; i += 1) {
      await sleep(i === 0 ? 1200 : 3000);

      var state = await secondOpinionApi('get', {
        submission_id: submissionId
      });

      renderSecondOpinion(root, state);

      var status = String(state && state.analysis && state.analysis.status || '').toLowerCase();
      if (status === 'complete' || status === 'error') return state;
    }

    throw new Error('Second Opinion is still running. You can leave this page and come back later.');
  }

  async function loadSecondOpinion(root, submissionId) {
    try {
      var state = await secondOpinionApi('get', {
        submission_id: submissionId
      });
      renderSecondOpinion(root, state);

      var status = String(state && state.analysis && state.analysis.status || '').toLowerCase();
      if (status === 'queued' || status === 'running') {
        pollSecondOpinion(root, submissionId, 140).catch(function (error) {
          setSecondOpinionStatus(root, error.message || String(error), true);
        });
      }

      return state;
    } catch (error) {
      console.error('[Track Insight Second Opinion load]', error);
      setSecondOpinionStatus(root, error.message || String(error), true);
      return { analysis: { status: 'error', error_message: error.message || String(error) }, analysis_audio_ready: false };
    }
  }

  function bindSecondOpinion(root, submissionId, player, initialState) {
    var button = soElement(root, '[data-ti-so-run]');
    var details = soElement(root, '[data-ti-second-opinion]');
    if (!button || button.dataset.tiSecondOpinionBound === 'true') return;

    button.dataset.tiSecondOpinionBound = 'true';
    var state = initialState || { analysis: { status: 'not_started' }, analysis_audio_ready: false };

    button.addEventListener('click', async function (event) {
      event.preventDefault();
      if (details) details.open = true;

      button.disabled = true;
      button.textContent = 'PREPARING…';
      setSecondOpinionStatus(root, 'Reading the decoded track…', false);

      try {
        var buffer = await waitForDecodedBuffer(player, 30000);
        var metrics = calculateTechnicalMetrics(buffer);
        renderSecondOpinionMetrics(root, metrics);

        state = await secondOpinionApi('get', {
          submission_id: submissionId
        });

        if (!state.analysis_audio_ready) {
          var mp3 = await encodeAnalysisMp3(root, buffer);
          await uploadAnalysisMp3(root, submissionId, mp3);
          state.analysis_audio_ready = true;
        }

        setSecondOpinionStatus(root, 'Sending the private analysis to Second Opinion…', false);

        await secondOpinionApi('run', {
          submission_id: submissionId,
          technical_metrics: metrics,
          force: true
        });

        state = {
          analysis: {
            status: 'queued',
            technical_metrics: metrics
          },
          analysis_audio_ready: true
        };
        renderSecondOpinion(root, state);

        state = await pollSecondOpinion(root, submissionId, 140);
      } catch (error) {
        console.error('[Track Insight Second Opinion run]', error);
        setSecondOpinionStatus(root, error && error.message ? error.message : String(error), true);
      } finally {
        var status = String(state && state.analysis && state.analysis.status || '').toLowerCase();
        button.disabled = status === 'queued' || status === 'running';
        button.textContent = status === 'complete' || status === 'error'
          ? 'Run Second Opinion Again'
          : (button.disabled ? 'ANALYSING…' : 'Run Second Opinion');
      }
    });
  }

  /* -----------------------------------------
     COMPLETE & PUBLISH
  ----------------------------------------- */

  function normalisedButtonText(element) {
    return String(element && element.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findPublishButton(root) {
    var candidates = Array.prototype.slice.call(
      root.querySelectorAll('button, a, input[type="button"], input[type="submit"]')
    );

    return candidates.find(function (element) {
      var text = element.tagName === 'INPUT'
        ? String(element.value || '').trim().toLowerCase()
        : normalisedButtonText(element);

      return (
        text === 'complete & publish' ||
        text === 'complete and publish' ||
        text === 'publish report' ||
        text === 'complete review'
      );
    }) || null;
  }

  function findSaveDraftButton(root) {
    var candidates = Array.prototype.slice.call(
      root.querySelectorAll('button, a, input[type="button"], input[type="submit"]')
    );

    return candidates.find(function (element) {
      var text = element.tagName === 'INPUT'
        ? String(element.value || '').trim().toLowerCase()
        : normalisedButtonText(element);

      return text === 'save draft';
    }) || null;
  }

  function publishStatusTarget(root, button) {
    var target = root.querySelector('[data-ti-publish-state]');
    if (target) return target;

    target = document.createElement('p');
    target.setAttribute('data-ti-publish-state', '');
    target.style.margin = '12px 0 0';
    target.style.color = '#607273';
    target.style.fontSize = '9px';
    target.style.fontWeight = '800';
    target.style.letterSpacing = '.1em';
    target.style.textTransform = 'uppercase';

    if (button && button.parentNode) {
      button.parentNode.insertBefore(target, button.nextSibling);
    } else {
      root.appendChild(target);
    }

    return target;
  }

  function setPublishState(root, button, message, isError) {
    var target = publishStatusTarget(root, button);
    target.style.color = isError ? '#D67E4A' : '#607273';
    target.textContent = message || '';
  }

  function setWorkspaceStatusComplete(root) {
    var status = root.querySelector('[data-ti-workspace-status]');

    if (status) {
      status.textContent = 'Complete';
    }

    var possibleStatusNodes = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (element) {
      var value = String(element.textContent || '').replace(/\s+/g, ' ').trim();
      return value === 'In Review';
    });

    possibleStatusNodes.forEach(function (element) {
      if (element.children.length === 0) {
        element.textContent = 'Complete';
      }
    });
  }

  function autosaveLooksBusy(root) {
    var messages = Array.prototype.slice.call(
      root.querySelectorAll(
        '[data-ti-assessment-save-state], ' +
        '[data-ti-sp-save-state], ' +
        '[data-ti-diagnostics-save-state], ' +
        '[data-ti-recommendations-save-state]'
      )
    );

    return messages.some(function (element) {
      var text = String(element.textContent || '').toLowerCase();
      return text.indexOf('saving') !== -1 || text.indexOf('unsaved') !== -1;
    });
  }

  async function waitForAutosaves(root, maxMs) {
    var started = Date.now();
    var minimumWaitUntil = started + 850;

    while (Date.now() - started < maxMs) {
      if (Date.now() >= minimumWaitUntil && !autosaveLooksBusy(root)) {
        return;
      }

      await new Promise(function (resolve) {
        window.setTimeout(resolve, 120);
      });
    }
  }

  function bindSaveDraft(root) {
    var button = findSaveDraftButton(root);
    if (!button || button.dataset.tiLiveDraftBound === 'true') return;

    button.dataset.tiLiveDraftBound = 'true';

    button.addEventListener('click', async function (event) {
      event.preventDefault();

      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'SAVING…';

      try {
        await waitForAutosaves(root, 5000);
        button.textContent = 'SAVED';
        setPublishState(root, findPublishButton(root), 'Draft saved');

        window.setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 900);
      } catch (error) {
        button.textContent = original;
        button.disabled = false;
        setPublishState(
          root,
          findPublishButton(root),
          error && error.message ? error.message : String(error),
          true
        );
      }
    });
  }

  function bindPublish(root, submissionId, submission) {
    var button = findPublishButton(root);
    if (!button || button.dataset.tiLivePublishBound === 'true') return;

    button.dataset.tiLivePublishBound = 'true';

    if (String(submission && submission.status || '').toLowerCase() === 'complete') {
      button.textContent = 'PUBLISHED';
      button.disabled = true;
      setPublishState(root, button, 'Track Insight is already published');
      return;
    }

    button.addEventListener('click', async function (event) {
      event.preventDefault();

      var tierInfo = serviceTierInfo(submission && submission.service_tier);

      if (tierInfo.video) {
        setPublishState(root, button, 'Checking required video review…');

        try {
          var videoCheck = await reviewerApi('get_video_review', {
            submission_id: submissionId
          });

          var videoState = videoCheck && videoCheck.video_review
            ? String(videoCheck.video_review.status || '').toLowerCase()
            : 'not_started';

          if (videoState !== 'ready') {
            setPublishState(
              root,
              button,
              'Video review required — upload and finalise the customer video before publishing this tier.',
              true
            );
            return;
          }
        } catch (videoError) {
          setPublishState(
            root,
            button,
            videoError && videoError.message
              ? videoError.message
              : 'Could not verify the video review before publishing.',
            true
          );
          return;
        }
      }

      if (tierInfo.midi) {
        setPublishState(root, button, 'Checking the 2 required MIDI enhancements…');

        try {
          var midiCheck = await midiReviewerApi('get_workflow', {
            submission_id: submissionId
          });

          var readyMidi = (midiCheck.enhancements || []).filter(function (item) {
            return String(item.status || '').toLowerCase() === 'ready';
          }).length;

          if (readyMidi !== 2) {
            setPublishState(
              root,
              button,
              'Track Insight Complete requires both MIDI enhancements to be finished before publishing.',
              true
            );
            return;
          }
        } catch (midiError) {
          setPublishState(
            root,
            button,
            midiError && midiError.message
              ? midiError.message
              : 'Could not verify the MIDI enhancements before publishing.',
            true
          );
          return;
        }
      }

      var confirmed = window.confirm(
        'Complete and publish this Track Insight? The customer will be able to access the finished report.'
      );

      if (!confirmed) return;

      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'PUBLISHING…';
      setPublishState(root, button, 'Saving final review changes…');

      try {
        await waitForAutosaves(root, 6000);

        setPublishState(root, button, 'Publishing Track Insight…');

        await reviewerApi('publish_report', {
          submission_id: submissionId
        });

        submission.status = 'Complete';
        submission.completed_at = new Date().toISOString();

        setWorkspaceStatusComplete(root);
        button.textContent = 'PUBLISHED';

        setPublishState(
          root,
          button,
          'Published successfully — sending the customer notification email…'
        );

        try {
          await notificationApi({
            submission_id: submissionId
          });

          setPublishState(
            root,
            button,
            'Published successfully — the customer has been notified by email'
          );
        } catch (notificationError) {
          console.error('[Track Insight notification email]', notificationError);

          setPublishState(
            root,
            button,
            'Published successfully — but the notification email could not be sent: ' +
              (notificationError && notificationError.message
                ? notificationError.message
                : String(notificationError)),
            true
          );
        }

        window.TrackInsightWorkspace = window.TrackInsightWorkspace || {};
        window.TrackInsightWorkspace.submission = submission;
      } catch (error) {
        console.error('[Track Insight publish]', error);
        button.disabled = false;
        button.textContent = original;
        setPublishState(
          root,
          button,
          error && error.message ? error.message : String(error),
          true
        );
      }
    });
  }

  function bindDownload(root, submissionId, submission) {
    var button = root.querySelector('[data-ti-download-original]');
    if (!button || button.dataset.tiLiveDownload === 'true') return;

    button.dataset.tiLiveDownload = 'true';

    button.addEventListener('click', async function () {
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Preparing Download…';

      try {
        var response = await reviewerApi('get_download_url', {
          submission_id: submissionId
        });

        if (!response || !response.url) {
          throw new Error('Download URL was not returned.');
        }

        var link = document.createElement('a');
        link.href = response.url;
        link.download = submission.original_filename || 'track-insight-original.wav';
        link.target = '_blank';
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('[Track Insight download]', error);
        setWorkspaceMessage(root, error.message || String(error), true);
      } finally {
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  }

  async function init() {
    if (window.Shopify && window.Shopify.designMode) return;

    var root = document.querySelector('[data-ti-reviewer-workspace]');
    if (!root || root.dataset.tiWorkspaceLiveReady === 'true') return;

    root.dataset.tiWorkspaceLiveReady = 'true';

    var submissionId = getSubmissionId();
    if (!submissionId) {
      setWorkspaceMessage(root, 'No submission ID was supplied.', true);
      return;
    }

    try {
      var session = await getSession();
      if (!session) {
        throw new Error('Reviewer sign-in required. Sign in once from the review queue; your reviewer session will then stay available across Track Insight tabs.');
      }

      setWorkspaceMessage(root, 'Loading live submission…');

      var response = await reviewerApi('get_submission', {
        submission_id: submissionId
      });

      if (!response || !response.submission) {
        throw new Error('Submission details were not returned.');
      }

      var submission = response.submission;

      if (submission.status === 'Submitted') {
        await reviewerApi('update_status', {
          submission_id: submissionId,
          status: 'In Review'
        });

        submission.status = 'In Review';
      }

      populateSubmission(root, submission);
      bindDownload(root, submissionId, submission);
      await initVideoReview(root, submissionId, submission);
      await initMidiWorkflow(root, submissionId, submission);

      var player = await createPlayer(root, submissionId);

      await loadLiveMarkers(root, submissionId, player);
      bindLiveMarkers(root, submissionId, player);

      var assessment = await loadLiveAssessment(root, submissionId);
      bindLiveAssessment(root, submissionId, assessment);

      var strengthsPriorities = await loadLiveStrengthsPriorities(root, submissionId);
      bindLiveStrengthsPriorities(
        root,
        submissionId,
        strengthsPriorities.assessment || assessment
      );

      var diagnostics = await loadLiveDiagnostics(root, submissionId);
      bindLiveDiagnostics(root, submissionId, diagnostics);

      var recommendations = await loadLiveRecommendations(
        root,
        submissionId,
        diagnostics
      );
      bindLiveRecommendations(root, submissionId, recommendations);

      var secondOpinionState = await loadSecondOpinion(root, submissionId);
      bindSecondOpinion(root, submissionId, player, secondOpinionState);

      bindSaveDraft(root);
      bindPublish(root, submissionId, submission);

      window.TrackInsightWorkspace = {
        submissionId: submissionId,
        submission: submission,
        player: player,
        api: reviewerApi,
        midiApi: midiReviewerApi,
        diagnosticsApi: diagnosticsApi,
        secondOpinionApi: secondOpinionApi,
        getCurrentTime: function () {
          return player ? player.getCurrentTime() : 0;
        }
      };
    } catch (error) {
      console.error('[Track Insight workspace]', error);
      setWorkspaceMessage(root, error && error.message ? error.message : String(error), true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
/* =========================================================
   TRACK INSIGHT — DIAGNOSTIC LIVE VALUE BRIDGE V2
   Tonal Balance shows text positions; Musical Effectiveness
   continues to show numeric /10 scores.
   ========================================================= */

(function () {
  'use strict';

  function clampMusicalValue(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 1;
    return Math.max(1, Math.min(10, Math.round(number)));
  }

  function clampTonalValue(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 0;
    return Math.max(-2, Math.min(2, Math.round(number)));
  }

  function tonalValueLabel(value) {
    switch (clampTonalValue(value)) {
      case -2: return 'Too Low';
      case -1: return 'Slightly Low';
      case 1: return 'Slightly High';
      case 2: return 'Too High';
      default: return 'Balanced';
    }
  }

  function updateDiagnosticValue(range) {
    if (!range || range.type !== 'range') return;

    var row = range.closest('.ti-workspace__diag-row');
    if (!row) return;

    var output = row.querySelector('[data-ti-range-output]');
    if (!output) return;

    if (range.hasAttribute('data-ti-tonal-diagnostic')) {
      var label = tonalValueLabel(range.value);

      /*
        Tonal labels are words rather than single-digit scores, so give the
        output its own proper column instead of allowing it to overflow into
        the Musical Effectiveness side of the diagnostics grid.
      */
      row.style.gridTemplateColumns = '96px minmax(0, 1fr) 108px';
      row.style.columnGap = '12px';

      output.textContent = label;
      output.style.minWidth = '0';
      output.style.width = 'auto';
      output.style.maxWidth = '108px';
      output.style.paddingRight = '10px';
      output.style.boxSizing = 'border-box';
      output.style.fontSize = '8px';
      output.style.letterSpacing = '.04em';
      output.style.whiteSpace = 'nowrap';
      output.style.textAlign = 'right';
      output.style.textTransform = 'uppercase';

      range.setAttribute('aria-valuetext', label);
      return;
    }

    output.textContent = String(clampMusicalValue(range.value));
  }

  function updateAllDiagnosticValues() {
    var ranges = document.querySelectorAll(
      '.ti-workspace__diag-row input[type="range"]'
    );

    Array.prototype.forEach.call(ranges, updateDiagnosticValue);
  }

  document.addEventListener('input', function (event) {
    var range = event.target;

    if (
      !range ||
      !range.matches('.ti-workspace__diag-row input[type="range"]')
    ) {
      return;
    }

    updateDiagnosticValue(range);
  });

  document.addEventListener('change', function (event) {
    var range = event.target;

    if (
      !range ||
      !range.matches('.ti-workspace__diag-row input[type="range"]')
    ) {
      return;
    }

    updateDiagnosticValue(range);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateAllDiagnosticValues,
      { once: true }
    );
  } else {
    updateAllDiagnosticValues();
  }

  document.addEventListener(
    'shopify:section:load',
    updateAllDiagnosticValues
  );
})();
/* =========================================================
   TRACK INSIGHT — REVIEWER PLAYER PRELOAD
   Low-risk performance optimisation.
   Starts loading WaveSurfer as soon as this asset runs so
   reviewer authentication / submission loading can happen
   in parallel with the waveform library download.
   ========================================================= */

(function () {
  'use strict';

  if (window.__MAG_TI_WAVESURFER_PRELOAD_V1) {
    return;
  }

  window.__MAG_TI_WAVESURFER_PRELOAD_V1 = true;

  var WAVESURFER_SRC =
    'https://unpkg.com/wavesurfer.js@6.6';

  var SUPABASE_ORIGIN =
    'https://jbllyryqhalyltkkkljn.supabase.co';

  function addPreconnect(href) {
    if (!href) return;

    var existing = document.querySelector(
      'link[rel="preconnect"][href="' +
        href +
      '"]'
    );

    if (existing) return;

    var link = document.createElement('link');

    link.rel = 'preconnect';
    link.href = href;
    link.crossOrigin = 'anonymous';

    document.head.appendChild(link);
  }

  function preloadWaveSurfer() {
    if (window.WaveSurfer) {
      return;
    }

    var existing = document.querySelector(
      'script[data-ti-workspace-wavesurfer]'
    );

    if (existing) {
      return;
    }

    var script =
      document.createElement('script');

    script.src = WAVESURFER_SRC;
    script.async = true;

    script.setAttribute(
      'data-ti-workspace-wavesurfer',
      ''
    );

    script.addEventListener(
      'error',
      function () {
        console.warn(
          '[Track Insight] WaveSurfer preload did not complete. The normal workspace loader will retry when needed.'
        );
      },
      { once: true }
    );

    document.head.appendChild(script);
  }

  addPreconnect(
    'https://unpkg.com'
  );

  addPreconnect(
    SUPABASE_ORIGIN
  );

  preloadWaveSurfer();
})();